import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const APP_LABEL = import.meta.env.VITE_APP_LABEL || "HabitNu";
const APP_ABBREVIATION = import.meta.env.VITE_APP_ABBREVIATION || APP_LABEL;

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)

    .init({
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        resources: {
            en: {
                translations: {
                    accessBanner: {
                        subscription: {
                            back: "Go Back",
                            description:
                                "To continue using the app and unlock all features, you’ll need an active subscription.",
                            header: "Access Is Paused!\n Subscribe To Continue.",
                            ended_description:
                                "Subscribe now to access your favorite features!",
                        },
                        subscribe: "View Plans & Subscribe",
                        subscribe_plan: "Subscribe",
                        subscription_ended:
                            "Oh no!\n Your program has ended 😢",
                        subscription_ended_india:
                            "Oh no!\n Your subscription is paused 😢",
                    },
                    And: "and",
                    Success: "Success",
                    activate: "Activate",
                    active_habits: "Active Habits",
                    ada_jotform_body:
                        "Project Power program reduces your risk of type 2 diabetes. Over the course of the program Project Power health coaches will work with you to lose weight,  break old habits, set attainable goals, and keep you motivated.",
                    ada_jotform_header: "Take the risk test and participate",
                    ada_jotform_submit: "LET'S GO!",
                    add: "Add",
                    at: "at",
                    archive: "Archive",
                    archived_habits: "Archived Habits",
                    ask_us_login: "<2>Need any help?</2> <1>Ask us.</1>",

                    back: "Back",
                    back_link: "Click on Back",
                    banner: {
                        welcome1: `Acceptance of the ${APP_LABEL} End User License Agreement is mandatory for participation in the program.`,
                        welcome2: `If you would like to use ${APP_LABEL} applications, please click 'Go Back' to accept.`,
                        welcome3:
                            "If you do not wish to accept, please click ‘Do Not Enroll’ below.",
                        diabetic1:
                            "Let's begin your registration. Please try to fill in as much of the information on the following forms as you can.",
                        diabetic2:
                            "All of your answers will be kept strictly confidential and never associated with your name.",
                        weight: "Please confirm your starting weight and remember, this is just the beginning! We will customize our recommendations for you based on this starting weight. From this day on we will help you form new Habits to help you reach your goal weight!",
                        complete1: `Congratulations! You have joined the ${APP_LABEL} Lifestyle Program.`,
                        complete2:
                            "If you haven't worked with your coach yet, they will be in touch with you in the next 3 business days to confirm your participation.",
                        complete3:
                            "Within the next week we will be placing an order for your digital scale if one is included with your program.",
                        complete4: `Please download the ${APP_LABEL} app on your phone by tapping on the link below`,
                        complete5: `In the meantime, download the ${APP_LABEL} app`,
                        eula_declined1: `Acknowledgment of the ${APP_LABEL} Terms and Conditions is mandatory for participation in the ${APP_LABEL} Program.`,
                        eula_declined2: `If you would like to go back and agree to the terms and conditions applicable to joining the program, please click "Go Back".`,
                        eula_declined3: `If you do not wish to acknowledge the Terms and Conditions of the ${APP_LABEL} Program, click the Disenroll Me button below.`,
                        signout_thankyou:
                            "Thank you. We wish you a successful journey towards better health.",
                    },
                    block_content: "Block Content",
                    block_user: "Block User",
                    bone_mass: "Bone Mass",

                    cancel: "Cancel",
                    change_password_hint:
                        "Must contain a letter, a number and a symbol. It must be at least 8 characters long.",
                    chat: "Chat",
                    chat_unacessible_toast_message:
                        "You are not currently assigned to any coach to chat",
                    change_password_error:
                        " is invalid.  It must contain a letter, a number and a symbol.  It must be at least 8 characters long.",
                    close: "Close",
                    Close: "Close",
                    cohort_selection: {
                        select: "Select Cohort",
                        select_cohort_list: "Select cohort from below list",
                        part_of_cohort: "You are part of below cohort",
                        requested_for:
                            "You've requested for below listed cohort",
                        congrats: "Congratulations",
                        part_of: "You are part of cohort",
                        your_request: "Your requests",
                        submit_request:
                            "Please submit a request to the cohort you would like to join",
                        no_cohorts_available:
                            "No Cohorts available to join. Please check after sometime",
                        confirm: "Please confirm",
                        are_you_sure:
                            "Are you sure you want to request for this cohort?",
                        request: "Request",
                        coach: "Coach",
                        days_to_go: "days to go",
                        started: "Started",
                        days_ago: "days ago",
                        request_to_join: "Your request to join cohort",
                        send_on: "has been send on",
                        notify_you:
                            "We will notify you as soon as your request is confirmed",
                        no_available_cohort:
                            "No Cohorts available to join. Please continue by clicking the next button and select a cohort later",
                        later: "I will do it later",
                        continue: "Continue",
                        request_now: "I want to request now",
                        note: "Please Note",
                        request_later:
                            "To request for a cohort later, you can click on the profile icon and navigate to Select Cohort link",
                    },
                    connecting: "Connecting",
                    confidence: "Confidence",
                    confirm_address: "Please confirm address",

                    dashboard: {
                        weight_loss_header: "Weight Loss Progress",
                        hey: "Hey",
                        this_week_progress: "This Week",
                        set_target: "Set Targets",
                        week: "Week",
                        present_weight: "Present Weight",
                        initial_weight: "Starting Weight",
                        target_weight: "Target Weight",
                        pounds: "Pounds(lbs)",
                        kilogram: "Kilograms(kg)",
                        lbs: "lbs",
                        present_weight_header: "Current Weight",
                    },
                    description: "Description",
                    details: "Details",
                    device_connect: "Connect to {{device}}",
                    device_connected: "{{device}} connected",
                    device_connecting: "{{device}} connecting",
                    device_disconnect: "Disconnect {{device}}",
                    device_disconnecting: "Disconnecting",
                    device_sync: "Sync now",
                    device_syncing: "Syncing",
                    dial_in: "Dial In",
                    disconnect: "Disconnect",
                    done: "Done",
                    down: "Down",

                    email_id: "Email",
                    email_placeholder: "Enter your registered email",
                    email_invalid: "Please Enter Valid Email ID",
                    email_enter: "Enter Your Registerd Email",
                    edit: "Edit",
                    every: "Every",
                    every_day: "Every Day",
                    errors: {
                        is_required: "is required",
                        not_a_number: "not a number",
                        more_than_zero: "should be more than zero",
                    },

                    feedback: {
                        title: "Feedback Form",
                        email: "Email",
                        enter_email: "Enter email",
                        subject_placeholder: "Enter the Subject",
                        feedback_placeholder: "Enter Description",
                        category: "Category",
                        subject: "Subject",
                        feedback: "Feedback",
                        upload: "Upload",
                        max_size: "Max size 15MB (gif, jpg, jpeg, png, pdf)",
                        upload_msg: "Select a file to Upload",
                        contact_us: "Contact Us",
                        my_request: "My Requests",
                        submit_request: "Submit a New Request",
                        view_request: "View Request",
                        no_requests: "There are no requests",
                        comment_placeholder: "Enter your comment",
                        select_category: "Please select a category.",
                        saved_feedback: "Successfully Saved the Feedback",
                        could_not_save: "Could not save the changes",
                    },

                    recipes: {
                        preference_header: "Let's Set Your Preferences",
                        preference_description:
                            "Habi will use your selections to tailor meal options just for you!",
                        preference_description_2:
                            "Please select all that apply.",
                    },
                    feedback_email_placeholder: "Enter your email",
                    need_help: "Need Help?",
                    no_match_email: "Could not find any users matching email",
                    go_back: "Go Back",
                    normal: "Normal",
                    low: "Low",
                    max_electro: "Max electrodermal activity for month",
                    muscle_mass: "Muscle Mass",
                    fat_mass: "Fat Mass",
                    login_with_otp: "Sign in with Code",
                    weight_goal_required: "",
                    weight_goal_less:
                        "Weight loss goal must be less than or equal to 999",
                    frequency: "Frequency",
                    fixed_days: "Fixed Days",
                    flexible_days: "Flexible Days",
                    filters: "Filters",
                    skip: "Skip",
                    goal: "Goal",
                    in_the: "in the",
                    info: "Info",
                    link: "Link",
                    morning: "Morning",
                    members: "Members",
                    mood: "Mood",
                    next: "Next",
                    night: "Night",
                    name: "Name",
                    no: "No",
                    noon: "Noon",
                    no_data: "No Data",
                    not_done: "Not Done",
                    neutral: "Neutral",
                    notes: "Notes",

                    offensive: "Offensive",
                    other: "Other",
                    sex: "Sex",
                    sex_at_birth: "Sex at Birth",

                    program_end_banner: {
                        ending_soon: "Your program is coming to a close.",
                        ended: "Your program ended!",
                        india_payment_required: "Subscription required!",
                        ends_today: "Your program ends today!",
                        keep_momentum:
                            "Keep your momentum going, subscribe to stay on track!",
                        subscribe_now: "Subscribe Now",
                        subscribe:
                            "Click subscribe now to unlock all features and get back on track with your goals.",
                        subscribe_btn: "Subscribe",
                        program_ending: "Your program is ending.",
                        subscribe_program: "Subscribe now to stay on track!",
                        program_ended: "Your program has ended!",
                    },

                    reminder: "Reminder",
                    reason: "Reason",
                    record: "Record",
                    recording: "Recording",
                    recording_starting: "Recording will begin soon",
                    recording_stop: "Stop Recording",
                    save: "Save",
                    select: "Select",
                    submit: "Submit",
                    shared_by: "is presenting",
                    category: "Category",
                    disenroll_user: "Successfully Disenrolled User",
                    profile_pic_updated: "Profile picture updated",
                    spam: "Spam",
                    report: "Report",
                    accept: "Accept",
                    decline: "Decline",
                    sign_me_up: "Sign me up",
                    sign_out: "Sign Out",
                    selected_comment: "Selected Comment",
                    selected_post: "Selected Post",
                    setting: "Settings",
                    times_per_week: "times per week",
                    time_per_week: "time per week",
                    manage_notification: "Notification Preferences",
                    up: "up",
                    unblock_user: "Unblock User",
                    unblock_discussion: "Unblock Discussion",
                    unblock_comment: "Unblock Comment",
                    upload: "Upload",
                    yes: "Yes",
                    calendar: "Calendar",
                    not_interested: "Not interested?",
                    disenroll_me: "Do Not Enroll",
                    notification_help_text:
                        'We will send you reminders based on the schedule you set when creating your habits. To ensure you receive these reminders, open the Settings menu on your device, locate the app, and make sure that "Allow Notifications" is turned ON.',
                    foods: {
                        add_success: "Successfully added",
                        update_success: "Updated successfully",
                        delete_from_list_confirm:
                            "Are you sure you want to remove this food from the list?",
                    },
                    form_model: {
                        welcome_description:
                            "Let’s start your personalization journey!",
                        welcome_secondary_description:
                            "Over the next few pages, you’ll answer some questions about your wellness goals.",
                        thank_you_description:
                            "Thanks! Your response has been submitted.",
                        continue: "Continue",
                        footer_done: "Submit",
                        footer_next: "Next",
                        footer_previous: "Previous",
                        date_placeholder: "Choose start date",
                        if_other: "Other",
                        specify_others: "Please specify other",
                    },
                    describe_yourself: "How do you identify?",
                    login: {
                        welcome_to: "Welcome to",
                        receive_verification_code: `How would you like to receive\n your verification code?`,
                        code_via_email: "Send Code Via Email",
                        code_via_text: "Send Code Via Text",
                        or: "OR",
                        code_success_header: "Code Sent Successfully!",
                        code_success_title_1:
                            "Your verification code has been sent to your registered",
                        email: "email address.",
                        phone: "phone number.",
                        code_success_title_2:
                            "Please check your inbox and enter the code to continue.",
                        code_success_title_3: " The code is valid for ",
                        code_success_title_4: "10 minutes.",
                        code_success_title_5:
                            " *Always check your spam folder ",
                        verify_code_header: "Verify your code",
                        verify_code_sub_header:
                            "Enter the six digit verification code you received.",
                        verify_code: "Verify Code",
                        code_expired_1: "Your code expired!",
                        code_expired_2: "The verification code has timed out.",
                        code_expired_3:
                            "Please request a new code and try again.",
                        code_expired_retry: "Retry",
                        forgot_password_header: "Forgot Password?",
                        forgot_password_text_1:
                            "Enter your email to get a link to reset your password.",
                        reset_send_success:
                            "Password Reset Link Sent Successfully!",
                        password_reset_text_1:
                            "Your password can be reset by clicking the link in your email.",
                        password_reset_text_2:
                            "If you have not received the link to reset your password in your email, please check your spam folder.",
                    },
                    onboarding_modal: {
                        header: "👋 Hi, I’m Habi!",
                        desc1: `Welcome to ${APP_LABEL}`,
                        desc2: "Let’s take a brief tour of the app together!",
                        sub: `Discover ${APP_LABEL}'s Resources`,
                        habi_tour: "Guided Tour",
                        sub_desc: "Wellness made simple—track, learn, grow.",
                        step1: {
                            desc: "🗣️ Let’s get social! Click here to chat with your team, coach, or join a meeting.",
                        },
                        step2: {
                            desc: "💬  Click here to head directly to your team discussion board!",
                        },
                        step3: {
                            desc: "Click here to log your meals and snacks— it’s so easy, you can even do it on the go! 🏃",
                        },
                        step4: {
                            desc: "Log your weight here, and watch those small wins turn into big results!",
                        },
                        step5: {
                            desc: "Track your exercise here, and connect the dots between your effort and progress! 💪",
                        },
                        step6: {
                            desc: "Click here to link your Fitbit, Garmin, or Apple Watch—then watch your activity sync automatically. Less logging, more moving! 🚴",
                        },
                        step7: {
                            desc: "Congrats -  you're all set! 🎉 If you would like to view this brief tour again,<br /> just click <b>Guided Tour</b> from your <b>Profile Menu</b>. 😉",
                            desc2: "If you would like to view this brief tour again, just click <b>Guided Tour</b> from your <b>Profile Menu</b>.",
                        },
                        maybe_later: "Maybe Later",
                        take_tour: "Take a Tour",
                        finish_header: "Congrats- you’re all set! 🎉",
                        finish_desc:
                            "If you need more info on the app features, just tap More. I'll be there, ready to help! 😉",
                    },
                    verify_phone: {
                        welcome_to: "Welcome to",
                        receive_verification_code: `How do you want to receive\n your verification code?`,
                        code_via_email: "Send Code Via Email",
                        code_via_text: "Send Code Via Text",
                        or: "OR",
                        code_success_header: "Code Sent Successfully!",
                        code_success_title_1:
                            "Your verification code has been sent to your registered",
                        email: "email address",
                        phone: "phone number",
                        code_success_title_2:
                            "Please check your inbox and enter the code to continue.",
                        code_success_title_3: "The code is valid for",
                        code_success_title_4: "10 minutes.",
                        verify_code_header: "Verify your phone number",
                        no_code: "Didn't receive the code?",
                        resend_code: "Resend Code",
                        verify_code_sub_header:
                            "Enter the six digit verification code you received.",
                        verify_code: "Verify",
                        code_expired_1: "Your code expired!",
                        code_expired_2: "The verification code has timed out.",
                        code_expired_3:
                            "Please request a new code and try again.",
                        code_expired_retry: "Retry",
                        forgot_password_header: "Forgot Password?",
                        forgot_password_text_1:
                            "Enter your email to get a link to reset your password.",
                        reset_send_success:
                            "Password Reset Link Sent Successfully!",
                        password_reset_text_1:
                            "Your password can be reset by clicking the link in your email.",
                        password_reset_text_2:
                            "If you have not received the link to reset your password in your email, please check your spam folder.",
                        alert_header: "Code Sent Successfully!",
                        alert_text: "Your verification code has been sent to",
                    },
                    discussion: {
                        report_comment: "Report this Comment",
                        report_post: "Report this Post",
                        confirm_block_user:
                            "Are you sure you want to block this user?",
                        confirm_unblock_discussion:
                            "Are you sure you want to unblock this post?",
                        confirm_unblock_comment:
                            "Are you sure you want to unblock this comment?",
                        confirm_block_content:
                            "Please select the option that best describes your problem.",
                        confirm_unblock_user:
                            "Are you sure you want to unblock this user?",
                        reason_placeholder: "Write your reason",
                        blocked_user: "You have blocked this user",
                        blocked_discussion: "You have blocked this post",
                        blocked_comment: "You have blocked this comment",
                        discussion_reactions: {
                            Like: "Like",
                            Love: "Love",
                            Clap: "Clap",
                            Celebrate: "Celebrate",
                            Insightful: "Insightful",
                            Happy: "Happy",
                            No_Reactions_yet: "No reactions yet",
                            You_reacted: "You reacted",
                            You_and: "You and",
                            other: "other",
                            others: "others",
                            reacted: "reacted",
                            Comments: "Comments",
                            Reactions: "Reactions",
                            All: "All",
                            Reacted_on: "Reacted on",
                            user_blocked: "Blocked User",
                        },
                    },
                    learn: {
                        empty: "No course configured for your program.",
                        no_content: "No content available for this course.",
                        header: "Learn New Habits",
                        video: "Video",
                        videos: "Videos",
                        handouts: "Handouts",
                        handout: "Handout",
                        links: "Links",
                        link: "Link",
                        forms: "Forms",
                        form: "Form",
                        video_content: "Video Content",
                        completed: "Completed",
                        hide_details: "Hide Details",
                        view_details: "View Details",
                        podcasts: "Podcasts",
                        podcast: "Podcast",
                        disclaimer:
                            "The podcasts in this section are created using artificial intelligence. The voices are simulated to help illustrate key concepts and real-life scenarios based on CDC-approved content. These examples are designed for educational purposes only and are not intended to replace professional medical advice. For questions about your health, please talk to a healthcare provider.",
                    },

                    podcast: {
                        podcast: "Podcast",
                        comimg_up_next: "Coming Up Next",
                        speed: "Speed",
                        play: "Play",
                        pause: "Pause",
                        next: "Next",
                        select_speed: "Select Playback Speed",
                    },
                    mandatoryContent: {
                        header: "Keep the flow going with handouts!",
                        header_desc:
                            "Reinforce what you learned with these companion guides.",
                        next_doc: "Next Document",
                        close: "Close",
                        mark_read: "Mark As Read",
                    },
                    mobileModal: {
                        header: `Get the ${APP_LABEL} App`,
                        description:
                            "Everything you need to achieve your goals on the go!",
                        download: "Download Now",
                    },
                    target: {
                        set_target: "Set Your Target",
                        set_small_achievable: "Set small, achievable goals",
                    },
                    food_dashboard: {
                        nutrition_details: "View Details",
                        food_targets: "Set Targets",
                        carbs: "Carbs",
                        protein: "Protein",
                        fat: "Fat",
                        sodium: "Sodium",
                        calories: "Calories",
                        view_logs: "View Logs",
                        logs: "Logs",
                    },
                    water_target: {
                        water_header: "Daily Water Target",
                        water_recommendation_text:
                            "Your recommended water intake is 80 oz (2400 ml) per day.",
                        daily_intake: "Daily water Intake",
                        log_custom: "Log Custom Amount",
                        water_dashboard_header: "Water Intake",
                        water_dashboard_sub_header: "Select an amount below",
                        water_info_text:
                            "An average glass of water contains 8 oz (approx. 240 ml).",
                        reset_confirmation:
                            "This will reset your water target values",
                        custom_edit_title: "Amount",
                        custom_edit_header: "Edit Custom Amount",
                        delte_confirmation:
                            "This water log will be deleted. Press Yes to confirm",
                        daily_intake_note:
                            "Your recommended daily water intake is 80 oz (2400 ml)",
                        minimum_water_error: "Minimum allowed target is 1.",
                        positive_quantity_error:
                            "Please enter a positive quantity.",
                    },
                    smart_insights: {
                        explore_insights:
                            "Your Smart Health insights are ready!",
                        title: "Smart Insights",
                        subtitle: "Get new insights every Monday!",
                        week_header: "Last Week at a Glance",
                        empty_state_message_one:
                            "Smart Health Insights are powered by you.",
                        empty_state_message_two:
                            "Log your food and activity minutes to unlock your insights.",
                        disclaimer: "Disclaimer",
                        goal_text: "Small Steps, Lasting Results",
                        disclaimer_text:
                            "Smart Insights are AI-generated based on your activity in the HabitNu Thrive program. They are provided for educational and wellness support only and are not medical advice. Always consult your healthcare provider regarding your health or treatment.",
                        close: "Close",
                        feedback_prompt: "Share Your Feedback",
                        feedback_header: "Anything else you'd like to share?",
                        feedback_subheader: "(optional)",
                        type_here: "Type here",
                        send: "Send",
                        empty_state_message:
                            "Smart Health Insights are powered by you. Log your food and activity minutes to unlock your insights.",
                        feedback_comment_label:
                            "Tell us a bit more about your experience...",
                        feedback_cancel_button: "Close",
                        disclaimer_acknowledge: "Close",
                        feedbackSuccess: "Feedback submitted successfully",
                        feedback_cleared: "Feedback cleared",
                        feedbackError: "Failed to submit feedback",
                    },
                    water_reminders: {
                        custom_tooltip_info: "Set your own time",
                        custom_tooltip: "Custom",
                        morning: "Morning",
                        afternoon: "Afternoon",
                        evening: "Evening",
                        morning_tooltip_info: "8:00",
                        afternoon_tooltip_info: "12:00",
                        evening_tooltip_info: "20:00",
                    },
                    water_intake: {
                        intake_unit_header: "Intake Unit",
                        reminders_link: "Set Reminders",
                        reminder_header: "Set Your reminders",
                        reminder_subtitle:
                            "Don’t forget to take a sip of water.",
                        reminder_title: "Reminders",
                        enter_custom: "Enter Custom Quantity",
                        delete_error: "Failed to delete water log",
                        delete_success: "Water log deleted successfully",
                        custom_reminder_question:
                            "What time(s) would you like your reminder(s)?",
                        custom: "Custom",
                        succeful_log_added: "Water logged successfully",
                        add_log_text: "No logs yet.Take a sip!",
                        header: "Progress",
                        back: "Back",
                        save: "Log",
                        edit: "Edit",
                    },
                    height_unit: {
                        feet_and_inch: "Height (Feet & Inches)",
                        cm: "Height (Centimeters)",
                    },
                    food_target: {
                        alert_text1:
                            "This will reset your calorie target and macronutrient percentages to recommended values",
                        reset_msg: "Targets reset successfully",
                        header: "Set Your Targets",
                        sub_header: "Set small, achievable goals.",
                        calorie_header:
                            "Enter your total daily calorie (Cal) intake.",
                        nutrition_header: "Nutrient Intake",
                        macro_header:
                            "Select desired macronutrient percentages.",
                        macro_sub_header: "Grams of each Macronutrient.",
                        reset: "Reset to Default",
                        success:
                            "Macronutrient targets and water target updated successfully",
                        success1: "Macronutrient targets updated successfully",
                        failure: "Failed to update macronutrient targets",
                        errors: {
                            "Protein Percentage must be greater than or equal to 10":
                                "Protein Percentage must be greater than or equal to 10",
                            "Protein Percentage must be a valid number":
                                "Protein Percentage must be a valid number",
                            "Carbohydrate Percentage must be greater than or equal to 10":
                                "Carbohydrate Percentage must be greater than or equal to 10",
                            "Carbohydrate Percentage must be less than or equal to 70":
                                "Carbohydrate Percentage must be less than or equal to 70",
                            "Carbohydrate Percentage must be a valid number":
                                "Carbohydrate Percentage must be a valid number",
                            "Fat Percentage must be greater than or equal to 10":
                                "Fat Percentage must be greater than or equal to 10",
                            "Fat Percentage must be less than or equal to 80":
                                "Fat Percentage must be less than or equal to 80",
                            "Fat Percentage must be a valid number":
                                "Fat Percentage must be a valid number",
                            "Calorie Target must be greater than or equal to 1200":
                                "Calorie Target must be greater than or equal to 1200",
                            "Calorie Target must be a valid number":
                                "Calorie Target must be a valid number",
                            "Target must be a valid number":
                                "Target must be a valid number",
                            "Calorie target must be less than 10000":
                                "Calorie target must be less than 10000",
                            percentage_sum:
                                "Macronutrient percentages must sum to 100",
                        },
                    },
                    nutrition_details: {
                        header: "Nutrition Details",
                        sub_header: "Get the lowdown on your diet's details",
                        nutrient: "Nutrient",
                        avg: "Average",
                        value: "Value",
                        goal: "Goal",
                        empty: "Please add meals",
                    },
                    habits: {
                        archive_title:
                            "Are you sure want to archive this Habit?",
                        activate_title:
                            "Are you sure you want to activate this Habit?",
                        add_dialog: {
                            empty: "You have not added any habits",
                            select_goal: "What is the goal for your Habit?",
                            suggested_habit_title: "{{goal_name}} Habits",
                            suggested_habit_subtitle:
                                "Try to find a habit description from the dropdown that fits the habit you want to work on.",
                            description_title:
                                "Describe the habit in more detail",
                            description_placeholder:
                                "How will you know you've practiced your habit?\nWhy are you forming this habit?\nWhat could get in the way of practicing this habit?",
                            reminder_title: "Send me a reminder every",
                            select_hint: "Select a habit that fits...",
                            custom_hint: "Type in your own.",
                            other: "Or choose any one from below",
                            archieved: "Archieved",
                        },
                        confirm_activate:
                            "Are you sure you want to Activate this Habit?",
                        confirm_archive:
                            "Are you sure you want to Archive this Habit?",
                        empty: "There are no habits to display",
                        archieve_empty:
                            "There are no archived habits to display",
                    },
                    notification_preference: {
                        notification_help_text:
                            'We will send you reminders based on the schedule you set when creating your habits. To ensure you receive these reminders, open the Settings menu on your device, locate the app, and make sure that "Allow Notifications" is turned ON.',
                        learn_notification_help_text:
                            "Learn about notification preferences.",
                    },
                    weekday: {
                        narrow_1: "M",
                        narrow_2: "T",
                        narrow_3: "W",
                        narrow_4: "T",
                        narrow_5: "F",
                        narrow_6: "S",
                        narrow_7: "S",
                        short_1: "Mon",
                        short_2: "Tue",
                        short_3: "Wed",
                        short_4: "Thu",
                        short_5: "Fri",
                        short_6: "Sat",
                        short_7: "Sun",
                        long_1: "Monday",
                        long_2: "Tuesday",
                        long_3: "Wednesday",
                        long_4: "Thursday",
                        long_5: "Friday",
                        long_6: "Saturday",
                        long_7: "Sunday",
                    },
                    meeting: {
                        detail_title: "Meeting Details",
                        joining_info: "Joining Info",
                        breakout_rooms: "Breakout Rooms",
                        breakout_room: "You are in Breakout Room {{ number }}",
                        upload_max_size: "Max size 15MB (gif, jpg, jpeg, png)",
                        joining_main_room: "Returning back to Main Room",
                        joining_room: "Joining breakout room",
                        poweroff_info:
                            "Are you sure you want to end the meeting?",
                        ended_msg: "Meeting has been ended",
                        rejoin: "Rejoin",
                        recording_retry:
                            "Recording could not be started. Retry?",
                        note_auto_save:
                            "Notes are auto-saved, but tap the save button after typing to make sure your note is saved.",
                        participant_notes: "Participant Notes",
                    },

                    password_exp1:
                        "Password url has been expired. Please click on",
                    password_exp2: "to change your password",
                    password_placeholder: "Enter your password",
                    payment_modal: {
                        access_restored: "You’re all set to keep going.",
                        auto_renewal: "Auto Renewal",
                        currency: "Currency",
                        could_not_process_payment:
                            "We couldn’t process your payment",
                        end_date: "End Date",
                        go_home: "Go Home",
                        manage_subscription: "Manage Subscription",
                        go_to_login: "Go to Login",
                        go_to_app: "Go to App",
                        next_billing_date: "Next Billing Date",
                        start_date: "Start Date",
                        sub_failed: "Payment Failed",

                        sub_status: "Subscription Status",
                        sub_success: "Subscription Successful",
                        payment_method: "Payment Method",
                        plan: "Plan",
                        renew_on: "Renew on",
                        try_again: "Please try again!",
                        unable_to_process:
                            "We’re unable to process your payment.",
                        home: "Home",
                        you_are_all_set: "You’re all set!",
                        receipt: "Receipt",
                        emailed: "Emailed",
                    },
                    pin: "Pin",
                    policy_and_terms:
                        "<0>Privacy Policy</0> and <2>Terms of Use</2>",
                    previous: "Previous",

                    initiation_message:
                        "Your time is very valuable to us. Taking some time to provide information to HabitNu can greatly improve our ability to help you. Please review the following forms which have been requested by your coach.",
                    fill_form_message:
                        "Please choose a form you would like to fill first.",
                    review_forms: "Review Forms",
                    network_error:
                        "Your internet connection is unstable. Try turning off your video or dialing in by phone.",
                    general_content: {
                        fitness_videos_header: "Fitness Videos",
                        fitness_video_text: "Workouts Designed for Every Body.",
                        try_these_next: "Try these next!",
                        no_video_error: "No Videos configured",
                        failed_to_load_content: "Failed to load video.",
                        exercise_videos: "Exercise Videos",
                        banner_description:
                            "Boost your routine with workouts that fit your style.",
                        workout_now: "Workout Now",
                        connected_devices: "Connect Devices",
                        connected_dev_desc:
                            "Sync your devices for seamless tracking and updates!",
                    },
                    Medication: "Medication",
                    "Add your medication": "Add your medication",
                    medication: {
                        "": "",
                        headers: {
                            add_medication: "Add Medication",
                            view_medication: "View Medication",
                            edit: "Edit Medication",
                            history: "Medication History",
                            log_history: "Log History",
                        },
                        log_success: "Medication logged successfully",
                        alertMsg:
                            "If this is an emergency, please call 911. If you are feeling uncomfortable, please reach out to your prescribing provider for medical advice.",
                        type_here: "Type here",
                        review_header: "How are you feeling today?",
                        symptoms_label: "Do you have any of these symptoms?",
                        symptoms_other:
                            "Please specify any other options not listed:",
                        "Weight Loss Medication": "Weight Loss Medication",
                        "Other Medication": "Other Medication",
                        medication: "Medication",
                        card_description: "Add your medication",
                        log: "Log",
                        add_time: "Add time",
                        add_time_label:
                            "What time do you want to take this medication?",
                        time: "Time",
                        your_medication: "Your Medication",
                        as_needed_medication: "As Needed Medications",
                        todays_logs: "Today's Log",
                        skipped: "Skipped",
                        taken: "Taken",
                        medication_empty:
                            "There are no medications to display.",
                        reminder_empty: "There are no medications to log.",
                        reminder_done: "Great job! You are all caught up!",
                        archived_medication: "Archived Medication",
                        next_reminder: "Next Reminder at",
                        till: "Till",
                        next_reminder_at: "Next reminder at",
                        archive: "Archive",
                        archive_description:
                            "See all your archived medication here.",
                        fixed_days: "Fixed Days",
                        form: {
                            name_label: "Medication Name",
                            name_placeholder: "Search for medicine",
                            strength_label: "Strength",
                            form_type_label: "Type/Form",
                            dosage_label: "Dosage",
                            dosage_description: "Each Time",
                            start_date_label: "From",
                            end_date_label: "To",
                            continuous_label:
                                "Continuous Medication (No end date)",
                            food_timing_label: "Timing Related to Food",
                            food_timing_placeholder: "Timing related to food",
                            frequency_label: "Frequency",
                            comment_label: "Comments",
                            comment_placeholder: "Type comments here",
                            reminder_label: "Medication Reminder",
                            unit_label: "Unit",
                        },
                        medication_timing: "Medication Timings",
                        view_history: "View History",
                        "Fixed Days": "Fixed Days",
                        Capsule: "Capsule",
                        Tablet: "Tablet",
                        Liquid: "Liquid",
                        Topical: "Topical",
                        Injection: "Injection",
                        Application: "Application",
                        Unit: "Unit",
                        unit: "Unit",
                        Ml: "ml",
                        ml: "ml",
                        Other: "Other",
                        "Before Food": "Before Food",
                        "After Food": "After Food",
                        Daily: "Daily",
                        "Every other day": "Every other day",
                        "Twice weekly": "Twice weekly",
                        Weekly: "Weekly",
                        "Every other week": "Every other week",
                        "As needed": "As needed",
                        Fixed: "Fixed",
                        Flexible: "Flexible",
                        Day: "Day",
                        Week: "Week",
                        Month: "Month",
                        Year: "Year",
                        Taken: "Taken",
                        "Not Taken": "Not Taken",
                        medication_history: "Medication History",
                        history_description:
                            "See your medication history here.",
                        no_history: "No Medication history available.",
                        Nausea: "Nausea",
                        Vomiting: "Vomiting",
                        Diarrhea: "Diarrhea",
                        Constipation: "Constipation",
                        Dizziness: "Dizziness",
                        Headache: "Headache",
                        "Hypoglycemia (low blood sugar level)":
                            "Hypoglycemia (low blood sugar level)",
                        "Injection site reaction": "Injection site reaction",
                    },
                    "All Occurrance": "All Occurrance",
                    "Ounce (oz)": "Ounce (oz)",
                    "Milliliter (ml)": "Milliliter (ml)",
                    Morning: "Morning",
                    Noon: "Noon",
                    Night: "Night",
                    "Required field": "Required field",
                    "Marked as Taken at": "Marked as Taken at",
                    "Marked as Not Taken at": "Marked as Not Taken at",
                    "Must be more than 0": "Must be more than 0",
                    "Should be after from date": "Should be after from date",
                    "Time already exist": "Time already exist",
                    recipe_book: {
                        generate_new_recipe: "Generate New Recipe",
                        upload_photo: "Upload Photo",
                        servings: "Servings",
                        create_recipe: "Create Your Recipe",
                        create_custom_recipe: "Create Custom Recipe",
                        please_enter_valid_serving_size:
                            "Please enter a valid serving size",
                        search_recipe: "Search Custom Recipe",
                        enter_serving_size: "Enter Serving Size",
                        recipe_name: "Recipe Name",
                        recipe_photo: "Recipe Photo",
                        delete_confirm:
                            "Are you sure you want to delete this recipe?",
                        invalid_serving_size:
                            "Serving size should be at least 0.25",
                        save_ingredient: "Add Ingredient",
                        preparation_instructions: "Preparation Instructions",
                        favourite_toast: "Recipe added to favorites",
                        unfavourite_toast: "Recipe removed from favorites",
                        ingredient_name: "Ingredient Name",
                        recipe_log_toast: "Recipe logged successfully",
                        add_ingredient_name: "Add Ingredient Name",
                        add_ingredient_quantity: "Add Serving Quantity",
                        serving_size_placeholder: "Add Serving Size",
                        no_recipe_header: "No custom recipes found",
                        no_recipe_description:
                            "You can create your own recipes or search for existing ones.",
                        cal: "cal",
                        for_servings: "for {{count}} servings",
                        delete_toast: "Recipe deleted successfully",
                        recipe_created_successfully:
                            "Recipe created successfully",

                        create_recipe_description:
                            "Add ingredients, set servings, and save to your recipe book.",
                        back: "Back",
                        recipe_updated_toast: "Recipe updated successfully",
                        edit_recipe_description:
                            "Update ingredients, servings, and save your changes.",
                        update_recipe: "Update Recipe",
                        add_custom: "Add Custom Ingredient",
                        recipe_updated_successfully:
                            "Recipe updated successfully",
                        vitamin_d: "Vitamin D",
                        calcium: "Calcium",
                        iron: "Iron",
                        potassium: "Potassium",
                        total_fat: "Total Fat",
                        saturated_fat: "Saturated Fat",
                        trans_fat: "Trans Fat",
                        cholesterol: "Cholesterol",
                        sodium: "Sodium",
                        total_carb: "Total Carbohydrate",
                        dietary_fiber: "Dietary Fiber",
                        sugars: "Total Sugars",
                        added_sugars: "Added Sugars",
                        protein: "Protein",
                        calories: "Calories",
                        name_placeholder: "Enter recipe name",
                        ing_added_toast: "added to recipe successfully",
                        ing_removed_toast: "removed from recipe successfully",
                        favoriteAdded: "Added to Favorites",
                        please_enter_ingredient_name: "Enter ingredient name",
                        add_at_least_one_ingredient:
                            "Add at least one ingredient",

                        add_ing: "Search & Add Ingredient",
                        ing_already_added_toast:
                            "{{ingredientName}} is already added",
                        custom_ingredient_added:
                            "Custom ingredient added successfully",
                        enter_recipe_name: "Enter recipe name",
                        remove_ing_toast: "Ingredient successfully removed",
                        servings_num: " Number of Servings",
                        servings_unit: "Serving Unit",
                        detailed_nutrition_facts: "Detailed Nutrition Facts",
                        update_recipe_text:
                            "Update your custom recipe details and ingredients.",
                        custom_recipes: "My Recipes",
                        ingredients: "Ingredients",
                        total_calories: "Total Calories",
                        generate: "Generate",
                        edit_recipe: "Edit Your Recipe",
                        invalid_serving_qty: "Minimum value should be 0.01",
                        recipe_book: "Recipe Book",
                        recipes: "Recipes",
                        recipe_book_desc_habi:
                            "Turn everyday ingredients into your perfect meal.",
                        recipe_book_desc:
                            "Search the web for delicious recipes and save your favorites in the app!",
                        recently_generated_recipes: "Recently Generated",
                        history_recipes: "History",
                        habi_recipes: "Habi's Recipes",
                        search_web: "Search the Web",
                        recipe_disclaimer:
                            "Please note: These are approximate values and can vary depending on the specific ingredients you use and their brands.",
                        instructions: "Instructions",
                        change_recipe_title: "Not loving this recipe?",
                        change_recipe_desc:
                            "Let’s change the recipe or say goodbye!",
                        regenerate: "Regenerate",
                        log_recipe: "Log Recipe",
                        set_preferences: "Set Preferences",
                        remove_from_favorite: "Remove from Favorites",
                        add_to_Favorite: "Add to Favorites",
                        delete_recipe: "Delete Recipe",
                        are_you_sure: "Are you sure?",
                        delete_recipe_confirm:
                            "This recipe will be deleted. Press Yes to confirm.",
                        recipe_generated: "Recipe Generated Successfully",
                        recipe_generating:
                            "Your recipe is getting generated...",
                        recipe_failed: "Failed to generate recipe",
                        back_to_recipe: "Back to Recipe",
                        recipe_soon:
                            "Your recipe will be generated soon. You can continue using the app in the meantime!",
                        disclaimer:
                            "These recipes are AI-generated. Please use discretion when reviewing the recipe or preparing the dish.",
                        disclaimer2:
                            "These recipes are for informational purposes only and do not constitute medical or nutritional advice. Some recipes may be AI-generated or sourced from third parties. We make no guarantees about accuracy, nutritional content, or dietary suitability. Always review ingredients for allergens and consult a qualified health professional as needed. By using these recipes, you assume all risks and release us, our affiliates, and partners from any liability related to outcomes, health issues, or allergic reactions.",
                        no_recipe_found:
                            "No Recipe found please check your search term",
                    },
                    target_weight_same_error:
                        "Target weight can't be the same as initial weight",
                    "Add Ingredients": "Add Ingredients",
                    "dietary restrictions": "Dietary restrictions",
                    "dietary preferences": "Dietary preferences",
                    "strictness of dietary preferences":
                        "Strictness of dietary preferences",
                    "macronutrient considerations":
                        "Macronutrient considerations",
                    "micronutrient considerations":
                        "Micronutrient considerations",
                    "local food preferences": "Local food preferences",
                    "diet goals": "Diet goals",
                    "food allergies": "Food allergies",
                    "specific dietary considerations":
                        "Specific dietary considerations",
                    "Let's make your meals work for you!":
                        "Let's make your meals work for you!",
                    "Select all the dietary restrictions that apply to you:":
                        "Select all the dietary restrictions that apply to you:",
                    "We want to know what you love!":
                        "We want to know what you love!",
                    "Select all your dietary preferences:":
                        "Select all your dietary preferences:",
                    "How committed are you to your food choices?":
                        "How committed are you to your food choices?",
                    "Let us know:": "Let us know:",
                    "Tell us your macronutrient style and specific needs:":
                        "Tell us your macronutrient style and specific needs:",
                    "We’ve got the details covered.":
                        "We’ve got the details covered.",
                    "Select your micronutrient needs:":
                        "Select your micronutrient needs:",
                    "Your local food preferences matter!":
                        "Your local food preferences matter!",
                    "Select all that apply:": "Select all that apply:",
                    "Let’s hit your targets!": "Let’s hit your targets!",
                    "What are your diet goals?": "What are your diet goals?",
                    "Stay safe and sound!": "Stay safe and sound!",
                    "Select all your food allergies:":
                        "Select all your food allergies:",
                    "Any special considerations?":
                        "Any special considerations?",
                    Kosher: "Kosher",
                    "Low Sugar": "Low Sugar",
                    "Low Fat": "Low Fat",
                    "Low Carb": "Low Carb",
                    "Gluten Free": "Gluten Free",
                    "High Fiber": "High Fiber",
                    "Mollusk Free": "Mollusk Free",
                    "Dairy Free": "Dairy Free",
                    "No Sugar": "No Sugar",
                    "High Protein": "High Protein",
                    "Alcohol Free": "Alcohol Free",
                    "Kidney Friendly": "Kidney Friendly",
                    "Low Potassium": "Low Potassium",
                    Mediterranean: "Mediterranean",
                    "No Oil Added": "No Oil Added",
                    "Pork Free": "Pork Free",
                    "Red Meat Free": "Red Meat Free",
                    "Sugar Conscious": "Sugar Conscious",
                    "Sulfite Free": "Sulfite Free",
                    Vegan: "Vegan",
                    Vegetarian: "Vegetarian",
                    Pescatarian: "Pescatarian",
                    Paleo: "Paleo",
                    Flexitarian: "Flexitarian",
                    Keto: "Keto",
                    DASH: "DASH",
                    Balanced: "Balanced",
                    "Very Strict": "Very Strict",
                    "I never deviate from my dietary preferences":
                        "I never deviate from my dietary preferences",
                    Flexible: "Flexible",
                    "I generally follow my dietary preferences but often make exceptions":
                        "I generally follow my dietary preferences but often make exceptions",
                    Moderate: "Moderate",
                    "I mostly follow my dietary preferences but occasionally deviate":
                        "I mostly follow my dietary preferences but occasionally deviate",
                    Water: "Water",
                    Standard: "Standard",
                    Folate: "Folate",
                    "Folate (Equivalent)": "Folate (Equivalent)",
                    Magnesium: "Magnesium",
                    "No Allergies": "No Allergies",
                    "Egg Free": "Egg Free",
                    "Soy Free": "Soy Free",
                    "Fish Free": "Fish Free",
                    "Celery Free": "Celery Free",
                    "Crustacean Free": "Crustacean Free",
                    "Lupine Free": "Lupine Free",
                    "Mustard Free": "Mustard Free",
                    "Peanut Free": "Peanut Free",
                    "Sesame Free": "Sesame Free",
                    "Shellfish Free": "Shellfish Free",
                    "Tree Nut Free": "Tree Nut Free",
                    "Wheat Free": "Wheat Free",
                    "FODMAP Free": "FODMAP Free",
                    "Folic Acid": "Folic Acid",
                    Seasonal: "Seasonal",
                    transactions: {
                        header: "Transactions & Invoice History",
                        no_invoices: "No invoices available",
                        validity: "Validity",
                        billing_history: "Billing History",
                    },
                    Monthly: "Monthly",
                    Yearly: "Yearly",
                    month: "Month",
                    year: "Year",
                    monthly: "mensual",
                    yearly: "anual",
                    "I don't use it enough": "I don't use it enough",
                    "Too expensive": "Too expensive",
                    "Switching to something else":
                        "Switching to something else",
                    "Just taking a break": "Just taking a break",
                    Other: "Other",
                    purchase: "Purchase",
                    renewal: "Renewal",
                    active: "active",
                    canceled: "canceled",
                    expired: "expired",
                    note: "Note",
                    subscriptions: {
                        billing_faq: "Billing FAQs",
                        contact_support: "Contact Support",
                        confirm_stop_auto_renew:
                            "Are you sure you want to stop auto-renewal?",
                        current_subscription: "Current Subscription",
                        desc: "Get full access to all app features and stay on track with your goals.",
                        terms: "By clicking <b>Subscribe</b>, you acknowledge and consent to our",
                        terms_external_subscription_link:
                            "By {{actionWord}} <b>Subscribe</b>, you acknowledge and consent to our",
                        terms_link: "Terms and Conditions.",
                        looking_for_payments:
                            "Looking for your payments or invoices?",
                        manage_subscriptions: "Manage Subscriptions",
                        member_since: "Member Since {{date}}",
                        need_help: "Need Help?",
                        continue: "Continue",
                        please_specify: "Please specify",
                        type_here: "Type here",
                        need_help_desc:
                            "Need help with something? We're here to assist you!",
                        plan: "Plan",
                        select_plan: "Select a plan",
                        transaction: "Transaction",
                        transaction_invoice_history:
                            "Transaction & Invoice History",
                        refund_policy: "Cancellation & Refund Policy",
                        stop_auto_renewal: "Stop Auto-Renewal",
                        next_billing_data:
                            "Your next billing date is <strong>{{date}}</strong>",
                        plan_expire_on:
                            "Your plan will expire on <strong>{{date}}</strong>",
                        stop_auto_renewal_apple:
                            "This subscription was made through iOS. To cancel or manage auto-renewal, please visit your Apple ID settings on your iPhone, iPad, or Mac.",
                        stop_auto_renewal_google:
                            "This subscription was purchased via Google Play. To cancel or manage auto-renewal, please go to your Google Play account settings on your Android device.",
                        subscribe_to_continue_now: "Subscribe to continue now!",
                        subscribe_to_continue: "Subscribe to continue",
                        subscribe_to_continue_desc_india_payment:
                            "Your subscription is currently paused. Renew your subscription to unlock access to your Thrive experience.",
                        already_subscribed: "You are already subscribed",
                        subscribe_to_continue_desc:
                            "Your program has ended, but your journey is just getting started.",
                        subscribe_to_continue_desc_program_ending:
                            "With all app features at your fingertips, you'll be empowered to achieve your goals and maintain your progress.",
                        subscription: "Subscription",
                        manage_subscription: "Manage Subscription",
                        privacy_policy: "Privacy Policy",

                        currency: "Currency",
                        start_date: "Start Date",
                        next_billing_date: "Next Billing Date",
                        auto_renew: "Auto-Renewal",
                        payment_method: "Payment Method",
                        renew_on: "Renew on",
                        end_date: "End Date",
                        your_next_billing_date: "Your next billing date is",
                        status: "Status",
                        sub_status: "Subscription Status",
                        click_to_unlock: "Click here to unlock all features.",
                        stop_auto_renewal_header: "Stop Auto-Renewal?",
                        stop_auto_renewal_desc:
                            "You will lose access to key features like food logging, recipes, and tracking once your plan ends on <strong>date</strong>.",
                        subscribe: "Subscribe",
                        end_auto_renewal: "End Auto-Renewal",
                        end_auto_renewal_header: "End Auto-Renewal?",
                        subscribe_and_get_everything:
                            "Subscribe and get everything!",
                        whats_included: "What's included",
                        why_ending_subscription:
                            "Why are you ending your subscription?",
                        no_plan_included: "No plans available",
                        sub_billing_history: "Billing History",
                    },
                    Geographical: "Geographical",
                    Organic: "Organic",
                    Sustainable: "Sustainable",
                    "I prefer foods that are local to my area":
                        "I prefer foods that are local to my area",
                    "I prefer foods that are in season":
                        "I prefer foods that are in season",
                    "Lose Weight": "Lose Weight",
                    "Maintain Weight": "Maintain Weight",
                    "Gain Weight": "Gain Weight",
                    "Improve Overall Health": "Improve Overall Health",
                    "Increase Muscle Mass": "Increase Muscle Mass",
                    "Immuno Supportive": "Immuno Supportive",
                    "Search Ingredients": "Search Ingredients",
                    "Serving size must be at least 1":
                        "Serving size must be at least 1",
                    explore: {
                        Discussion: "Discussion",
                        Recipes: "Recipes",
                        "Fitness Videos": "Fitness Videos",
                        Medications: "Medications",
                    },
                    food_group: {
                        meal: "Meal",
                        review_meal: "Create Meal",
                        tweak_combo:
                            "Group your go-to meals for quicker tracking!",
                        breakfast_mon: "Monday's Breakfast",
                        meal_name: "Meal Name",
                        remove_photo: "Remove",
                        foods_added: "Food items added to the meal",
                        add_more: "Add Food",
                        food_success: "Food Added Successfully!",
                        save_meal: "Save Meal",
                        meal_created: "Meal created",
                        meal_updated: "Meal updated",
                        save_group_failed:
                            "Failed to save group. Please try again.",
                        name_required: "Meal Name is required.",
                        add_2_foods: "Add at least 2 foods to create a meal.",
                        my_meals: "My Meals",
                        edit_meal: "Edit Meal",
                        log_meal: "Log Meal",
                        createLogGroupMessage:
                            "Failed to log meal. Please try again.",
                        no_food_found: "No food found",
                        no_data: "No data",
                        create_meal: "Create Meal",
                        meal_logged_success: "Meal logged successfully",
                        log_meal_error:
                            "Meal can not be logged. Please try again.",
                        meal_deleted_success: "Meal deleted successfully",
                        delete_meal_error:
                            "Meal can not be deleted. Please try again.",
                        log_all_foods:
                            "Are you sure you want to log all {{count}} foods in {{name}} as {{mealType}}?",
                        food_delete_confirm:
                            "This food will be deleted. Press Yes to confirm.",
                        foods: "Foods",
                        Foods: "Foods",
                        upload_photo: "Upload Photo",
                        delete_meal_confirm:
                            "Are you sure you want to delete this meal?",
                    },
                    "Add breakfast": "Add Breakfast",
                    "Add lunch": "Add Lunch",
                    "Add dinner": "Add Dinner",
                    "Add snacks": "Add Snacks",
                },
                custom_recipe: {},
            },
            es: {
                translations: {
                    accessBanner: {
                        subscription: {
                            back: "Regresa",
                            description:
                                "Para seguir usando la aplicación y desbloquear todas las funciones, necesitará una suscripción activa.",
                            header: "¡El acceso está en pausa!\n Suscríbete para continuar.",
                            ended_description:
                                "¡Suscríbete ahora para acceder a tus funciones favoritas!",
                        },
                        subscribe: "Ver planes y suscribirse",
                        subscribe_plan: "Suscribirse",
                        subscription_ended:
                            "¡Oh no!\n Tu programa ha terminado 😢",
                    },
                    Success: "Éxito",
                    activate: "Activar",
                    active_habits: "Hábitos activos",
                    ada_jotform_body:
                        "El programa Project Power reduce su riesgo de diabetes tipo 2. A lo largo del programa, los entrenadores de salud de Project Power trabajarán con usted para perder peso, romper viejos hábitos, establecer metas alcanzables y mantenerlo motivado.",
                    ada_jotform_header: "Tome la prueba y participe",
                    ada_jotform_submit: "Vámonos!",
                    add: "Agregar",
                    at: "en",
                    archive: "Archivo",
                    archived_habits: "Hábitos archivados",
                    ask_us_login:
                        "<2>¿Necesita ayuda?</2> <1>Mándenos un mensaje.</1>",

                    "No Food Logged": "No se registraron alimentos",
                    "Preferences saved successfully!":
                        "¡Preferencias guardadas exitosamente!",
                    "Failed to save preferences. Please try again.":
                        "No se pudieron guardar las preferencias. Inténtalo de nuevo.",
                    "Meal logged successfully!":
                        "¡Comida registrada exitosamente!",
                    "Failed to log meal. Please try again.":
                        "No se pudo registrar la comida. Inténtalo de nuevo.",
                    "Failed to generate meal. Please try again.":
                        "No se pudo generar la comida. Inténtalo de nuevo.",
                    "Recipe added to favorites!":
                        "¡Receta añadida a favorites!",
                    "Recipe removed from favorites!":
                        "¡Receta eliminada de favorites!",
                    "Failed to toggle favorite. Please try again.":
                        "No se pudo activar/desactivar favoritos. Inténtalo de nuevo.",
                    Play: "Reproducir",
                    "What meal would you like to log?":
                        "¿Qué comida te gustaría registrar?",
                    "Serving Size": "Tamaño de la porción",
                    "Click here": "haga clic aquí",
                    "to view the full recipe": "para ver la receta completa",
                    "View Full Recipe": "Ver receta completa",
                    "Nutrition Information": "Información nutricional",
                    Ingredients: "Ingredientes",
                    Instructions: "Instrucciones",
                    "Ready to dive into the recipe? Click the button below to explore the full instructions and start cooking!":
                        "¿Listo para sumergirte en la receta? ¡Haz clic en el botón de abajo para explorar las instrucciones completas y empezar a cocinar!",
                    "Add files": "Agregar archivos",
                    "No options": "Sin opciones",
                    "Total Time": "Tiempo total",
                    "Prep time": "Tiempo de preparación",
                    "Cook time": "Tiempo de cocción",
                    "Water target was reset":
                        "Se restableció el objetivo de agua",
                    Servings: "Porciones",
                    feedback: {
                        title: "Formulario de retroalimentación",
                        email: "ID de correo electrónico",
                        enter_email: "Ingrese su correo electrónico",
                        subject_placeholder: "Ingrese el asunto",
                        feedback_placeholder: "Ingrese descripción",
                        category: "Categoría",
                        subject: "Asunto",
                        feedback: "Comentarios",
                        upload: "Cargar",
                        max_size:
                            "Tamaño máximo 15 MB (gif, jpg, jpeg, png, pdf)",
                        upload_msg: "Seleccionar un archivo para subir",
                        contact_us: "Contáctanos",
                        my_request: "Mi solicitud",
                        submit_request: "Enviar una nueva solicitud",
                        view_request: "Ver solicitud",
                        no_requests: "No hay solicitudes",
                        comment_placeholder: "Ingrese su comentario",
                        select_category: "Por favor, seleccione una categoría",
                        saved_feedback: "Retroalimentación guardada con éxito",
                        could_not_save: "No se pudieron guardar los cambios",
                    },
                    recipes: {
                        preference_header:
                            "Vamos a configurar tus preferencias",
                        preference_description:
                            "Ayúdanos a crear mejores comidas para ti. Selecciona todas las opciones que te apliquen:",
                        preference_description_2:
                            "Seleccione todas las que correspondan.",
                    },
                    "Login/Registration": "Iniciar sesión/Registro",
                    "Create New Password": "Crear nueva contraseña",
                    "Create Your Password": "Crea tu contraseña",
                    "Enter Your Password Again":
                        "Ingresa tu contraseña nuevamente",
                    "Enter your new password to reset":
                        "Ingresa tu nueva contraseña para restablecerla.",
                    default: "predeterminado",
                    sex: "Sex",
                    sex_at_birth: "Sexo al nacer",

                    program_end_banner: {
                        ending_soon: "Tu programa está por finalizar.",
                        ended: "Tu programa terminó.",
                        ends_today: "¡Tu programa termina hoy!",
                        keep_momentum:
                            "Mantén tu impulso, ¡suscríbete para seguir en el camino!",
                        subscribe_now: "Suscríbete ahora",
                        subscribe:
                            "Haz clic en Suscribirte ahora para desbloquear todas las funciones y retomar tus objetivos.",
                        subscribe_btn: "Suscribirse",
                        program_ending: "Su programa está finalizando.",
                        subscribe_program:
                            "¡Suscríbete ahora para estar al día!",
                        program_ended: "¡Tu programa ha terminado!",
                    },

                    disenroll_user: "Usuario desinscrito exitosamente",
                    profile_pic_updated: "Foto de perfil actualizada",
                    errors: {
                        is_required: "se requiere",
                        not_a_number: "not a number",
                        more_than_zero: "should be more than zero",
                    },
                    food_dashboard: {
                        nutrition_details: "Ver detalles",
                        food_targets: "Establecer objetivos",
                        carbs: "Carbohidratos",
                        protein: "Proteína",
                        fat: "Grasa",
                        sodium: "Sodio",
                        calories: "Calorías",
                        view_logs: "Ver registros",
                        logs: "Registros",
                    },
                    water_target: {
                        water_header: "Objetivo diario de agua",
                        water_recommendation_text:
                            "Your recommended water intake is 80 oz (2400 ml) per day.",
                        log_custom_amount: "Registrar cantidad personalizada",
                        daily_intake: "Consumo de agua diario",
                        water_dashboard_header: "Consumo de agua",
                        water_dashboard_sub_header:
                            "Elige una cantidad a continuación",
                        water_info_text:
                            "Un vaso de agua promedio contiene 8 oz (aprox. 240 ml).",
                        reset_confirmation:
                            "Esto restablecerá los valores de tu objetivo de agua",
                        custom_edit_title: "Cantidad",
                        custom_edit_header: "Selecciona una cantidad",
                        delte_confirmation:
                            "Este registro de agua será eliminado. Presiona Sí para confirmar",
                        daily_intake_note:
                            "Se recomienda que tomes 80 oz (2400 ml) de agua al día",
                        log_custom: "Registrar cantidad personalizada",
                        minimum_water_error:
                            "El objetivo mínimo permitido es 1",
                        positive_quantity_error:
                            "Por favor, ingrese una cantidad positiva",
                    },
                    water_reminders: {
                        custom_tooltip_info: "Establecer tu propia hora",
                        custom_tooltip: "Personalizado",
                        morning: "Mañana",
                        afternoon: "Tarde",
                        evening: "Noche",
                        morning_tooltip_info: "Mañana 8:00 AM",
                        afternoon_tooltip_info: "Tarde 12:00 PM",
                        evening_tooltip_info: "Noche 8:00 PM",
                    },
                    water_intake: {
                        intake_unit_header: "Unidad de consumo",
                        reminders_link: "Configurar recordatorios",
                        reminder_header: "Establecer tus recordatorios",
                        reminder_subtitle: "No olvides tomar un sorbo de agua.",
                        reminder_title: "Recordatorios",
                        edit: "Editar",
                        delete: "Eliminar",
                        enter_custom: "Especifica la cantidad manualmente",
                        delete_error: "Error al eliminar el recordatorio",
                        delete_success: "Recordatorio eliminado con éxito",
                        custom_reminder_question:
                            "A qué hora(s) te gustaría recibir tus recordatorios?",
                        custom: "Personalizado",
                        add_log_text: "Aún no hay registros. ¡Toma un sorbo!",
                        succeful_log_added: "Se registró el agua correctamente",
                        header: "Progreso",
                        back: "Atrás",
                        save: "Registro",
                    },
                    food_target: {
                        alert_text1:
                            "Esto restablecerá tu objetivo de calorías y los porcentajes de macronutrientes a los valores recomendados",
                        alert_text2: "Sí",
                        alert_text3:
                            "restablecerá tus objetivos de nutrición y calorías a la configuración predeterminada según tu peso actual. ¿Estás seguro de que deseas continuar?",
                        reset_msg: "Objetivos restablecidos con éxito",
                        header: "Establece tu objetivo de nutrientes",
                        sub_header: "Establece metas pequeñas y alcanzables",
                        calorie_header:
                            "Ingresa tu consumo total diario de calorías (Cal).",
                        macro_header:
                            "Selecciona los porcentajes deseados de macronutrientes.",
                        macro_sub_header: "Gramos de cada macronutriente.",
                        reset: "Restablecer los valores predeterminados",
                        success:
                            "Los objetivos de macronutrientes se actualizaron correctamente",
                        success1:
                            "Los objetivos de macronutrientes se actualizaron correctamente",
                        failure:
                            "Error al actualizar los objetivos de macronutrientes",
                        errors: {
                            "Protein Percentage must be greater than or equal to 10":
                                "El porcentaje de proteína debe ser mayor o igual a 10",
                            "Protein Percentage must be a valid number":
                                "El porcentaje de carbohidratos debe ser menor o igual a 70",
                            "Carbohydrate Percentage must be greater than or equal to 10":
                                "El porcentaje de carbohidratos debe ser mayor o igual a 10",
                            "Carbohydrate Percentage must be less than or equal to 70":
                                "El porcentaje de carbohidratos debe ser menor o igual a 70",
                            "Carbohydrate Percentage must be a valid number":
                                "El porcentaje de carbohidratos debe ser un número válido",
                            "Fat Percentage must be greater than or equal to 10":
                                "El porcentaje de grasa debe ser mayor o igual a 10",
                            "Fat Percentage must be less than or equal to 80":
                                "El porcentaje de grasa debe ser menor o igual a 80",
                            "Fat Percentage must be a valid number":
                                "El porcentaje de grasa debe ser un número válido",
                            "Calorie Target must be greater than or equal to 1200":
                                "El objetivo de calorías debe ser mayor o igual a 1200",
                            "Calorie Target must be a valid number":
                                "El objetivo de calorías debe ser un número válido",
                            "Target must be a valid number":
                                "El objetivo debe ser un número válido",
                            "Calorie target must be less than 10000":
                                "El objetivo de calorías debe ser menor a 10000",
                            percentage_sum:
                                "Los porcentajes de macronutrientes deben sumar 100",
                        },
                    },
                    height_unit: {
                        feet_and_inch: "Altura (pies y pulgadas)",
                        cm: "Altura (centímetros)",
                    },
                    nutrition_details: {
                        header: "Detalles de nutrición",
                        sub_header:
                            "Obtén la información completa sobre tu alimentación ",
                        nutrient: "Nutriente",
                        avg: "Average",
                        value: "Valor",
                        goal: "Metas",
                        empty: "Por favor, añade comidas",
                    },
                    email_id: "ID de correo electrónico",
                    email_placeholder:
                        "Ingresa tu ID de correo electrónico registrado",
                    feedback_email_placeholder:
                        "Ingresa tu ID de correo electrónico registrado",
                    need_help: "¿Necesitas ayuda?",
                    password_placeholder: "Ingresa tu contraseña",
                    describe_yourself: "Género",
                    login: {
                        welcome_to: "Bienvenido al",
                        receive_verification_code: `¿Cómo desea recibir su código de verificación?`,
                        code_via_email: "Enviar código por correo electrónico.",
                        code_via_text: "¡Código enviado con éxito!",
                        or: "O",
                        code_success_header: "¡Código enviado con éxito!",
                        code_success_title_1:
                            "Tu código de verificación ha sido enviado",
                        email: "a tu dirección de correo electrónico registrada",
                        phone: "a tu número de teléfono registrado",
                        code_success_title_2:
                            "Por favor revisa tu bandeja de entrada e introduce el código para continuar.",
                        code_success_title_3: "El código es válido por",
                        code_success_title_4: "10 minutos",
                        code_success_title_5:
                            " *Siempre revisa tu carpeta de spam.",
                        verify_code_header: "Verifica tu código",
                        verify_code_sub_header:
                            "Ingresa el código de seis dígitos que recibiste.",
                        verify_code: "de verificar código",
                        code_expired_1: "¡Tu código ha expirado!",
                        code_expired_2:
                            "El código de verificación ha expirado.",
                        code_expired_3:
                            "Por favor solicita un nuevo código e intenta nuevamente.",
                        code_expired_retry: "Reintentar",
                        forgot_password_header: "¿Olvidaste tu contraseña?",
                        forgot_password_text_1:
                            "Ingresa tu dirección de correo electrónico para recibir un enlace y restablecer tu contraseña.",
                        reset_send_success:
                            "¡Enlace para restablecer la contraseña enviado con éxito!",
                        password_reset_text_1:
                            "Puedes restablecer tu contraseña haciendo clic en el enlace de tu correo electrónico.",
                        password_reset_text_2:
                            "Si no has recibido el enlace para restablecer tu contraseña en tu correo, por favor revisa tu carpeta de spam.",
                    },
                    onboarding_modal: {
                        header: "¡Hola, soy Habi! 👋",
                        desc1: `Bienvenido a ${APP_LABEL}`,
                        desc2: "¡Hagamos un recorrido por la aplicación juntos!",
                        sub: `Descubre los recursos de ${APP_LABEL}`,
                        habi_tour: "Recorrido guiado",
                        sub_desc:
                            "Bienestar hecho simple: registra, aprende y crece.",
                        point1: {
                            title: "Registro de alimentos",
                            desc: "Registra tus comidas fácilmente y lleva un seguimiento de tu nutrición.",
                        },
                        point2: {
                            title: "Seguimiento de la salud",
                            desc: "Controla tu peso, actividad y estadísticas de salud.",
                        },
                        point3: {
                            title: "Aprende con contenido",
                            desc: "Amplía tu conocimiento sobre bienestar con contenido seleccionado.",
                        },
                        point4: {
                            title: "Seguimiento de hábitos",
                            desc: "Crea y mantén hábitos que respalden tus objetivos.",
                        },
                        point5: {
                            title: "Foro de discusión",
                            desc: "Conéctate, comparte y encuentra motivación con otros.",
                        },
                        point6: {
                            title: "Videos",
                            desc: "Mira videos para aprender y crecer.",
                        },
                        step1: {
                            desc: "🗣️ ¡Hablemos! Toca aquí para chatear con tu equipo, tu coach o unirte a una reunión.",
                        },
                        step2: {
                            desc: "💬 ¡Toca aquí para ir directamente al tablero de discusión de tu equipo!",
                        },
                        step3: {
                            desc: "Haz clic aquí para registrar tus comidas y snacks— ¡es tan fácil que puedes hacerlo incluso mientras te desplazas! 🏃",
                        },
                        step4: {
                            desc: "Registra tu peso aquí y observa cómo esos pequeños logros se convierten en grandes resultados.",
                        },
                        step5: {
                            desc: "Registra tu ejercicio aquí y conecta los puntos entre tu esfuerzo y tu progreso. 💪",
                        },
                        step6: {
                            desc: "Haz clic aquí para vincular tu Fitbit, Garmin o Apple Watch—y observa cómo tu actividad se sincroniza automáticamente.<br />¡Menos registros, más movimiento! 🚴",
                        },
                        step7: {
                            desc: "¡Felicidades! Todo está listo! 🎉 Si deseas ver este breve recorrido nuevamente,<br /> solo haz clic en <b>Recorrido guiado</b> desde el <b>menú de tu perfil</b>. 😉",
                            desc2: "Si deseas ver este breve recorrido nuevamente, solo haz clic en <b>Recorrido guiado</b> desde el <b>menú de perfil</b>.",
                        },
                        maybe_later: "Quizás más tarde",
                        take_tour: "Tomar el recorrido",
                        finish_header: "¡Felicidades, ya está todo listo! 🎉",
                        finish_desc:
                            "Si necesitas más información sobre las funciones de la app, solo toca Más. ¡Estaré ahí, listo para ayudarte! 😉",
                    },
                    verify_phone: {
                        welcome_to: "Bienvenido al",
                        receive_verification_code: `¿Cómo desea recibir su código de verificación?`,
                        code_via_email: "Enviar código por correo electrónico.",
                        code_via_text: "Enviar código por mensaje de texto",
                        or: "O",
                        code_success_header: "¡Código enviado con éxito!",
                        code_success_title_1:
                            "Tu código de verificación ha sido enviado a tu ",
                        email: "dirección de correo electrónico registrada.",
                        phone: "número de teléfono registrado.",
                        code_success_title_2:
                            "Por favor revisa tu bandeja de entrada e introduce el código para continuar.",
                        code_success_title_3: "El código es válido por ",
                        code_success_title_4: "10 minutos",
                        verify_code_header: "Verifica tu número de teléfono.",
                        no_code: "¿No recibiste el código?",
                        resend_code: "Reenviar código",
                        verify_code_sub_header:
                            "Ingresa el código de seis dígitos que recibiste.",
                        verify_code: "Verificar",
                        code_expired_1: "¡Tu código ha expirado!",
                        code_expired_2:
                            "El código de verificación ha expirado.",
                        code_expired_3:
                            "Por favor solicita un nuevo código e intenta nuevamente.",
                        code_expired_retry: "Reintentar",
                        alert_header: "¡Código enviado con éxito!",
                        alert_text: "Tu código de verificación ha sido enviado",
                    },
                    dashboard: {
                        weight_loss_header: "Progreso de pérdida de peso",
                        hey: "Hola",
                        this_week_progress: "El progreso de esta semana",
                        set_target: "Establecer objetivos",
                        week: "Semana",
                        Week: "Semana",
                        present_weight: "Peso actual",
                        initial_weight: "Peso inicial",
                        target_weight: "Peso meta",
                        lbs: "libras",
                        pounds: "Libras(lbs)",
                        kilogram: "Kilogramo(kg)",

                        present_weight_header: "Peso actual",
                    },
                    target: {
                        set_target: "Establecer tu objetivo",
                        set_small_achievable:
                            "Establece metas pequeñas y alcanzables",
                    },
                    cohort_selection: {
                        select: "Seleccionar cohorte",
                        select_cohort_list:
                            "Selecciona un grupo de la lista de abajo",
                        part_of_cohort: "Eres parte del siguiente grupo",
                        requested_for:
                            "Has solicitado el siguiente grupo listado",
                        congrats: "¡Felicidades!",
                        part_of: "Eres parte del cohorte",
                        your_request: "Tus solicitudes",
                        submit_request:
                            "Por favor, envía una solicitud al grupo al que te gustaría unirte",
                        no_cohorts_available:
                            "No hay grupos disponibles para unirte. Por favor, revisa más tarde",
                        confirm: "Por favor confirma",
                        are_you_sure:
                            "¿Estás seguro de que quieres solicitar unirte a este grupo?",
                        request: "Solicitud",
                        coach: "entrenador ",
                        days_to_go: "días restantes",
                        started: "iniciado",
                        days_ago: "hace días",
                        request_to_join: "Tu solicitud para unirte al grupo",
                        send_on: "ha sido enviada el",
                        notify_you:
                            "Te notificaremos tan pronto como tu solicitud sea confirmada",
                        no_available_cohort:
                            "No hay grupos disponibles para unirte. Continúa y selecciona un grupo más tarde",
                        later: "Lo haré después",
                        continue: "Continuar",
                        request_now: "Quiero solicitar ahora",
                        note: "Por favor, ten en cuenta",
                        request_later:
                            "Para solicitar un grupo más tarde, haz clic en el ícono de perfil y navega al enlace 'Seleccionar Grupo'",
                    },
                    "Joining Info": "Información para ingresar",
                    "Join By Phone": "Unirse por teléfono",
                    "Add Note to Coach": "Agregar nota al coach",
                    "Join by HabitNu Meet": "Unirse a través de HabitNu Meet",
                    "Edit Note": "Editar nota",
                    Attendees: "Participantes",
                    Location: "Ubicación",
                    Organizers: "Organizadores",
                    Host: "Anfitrión",
                    calendar: "Calendario",

                    goal: "Meta",
                    login_with_otp: "Iniciar sesión con código",
                    go_back: "Regresa",
                    not_interested: "No estoy interesado/a",
                    disenroll_me: "No inscribirse",
                    email_invalid:
                        "Ingrese una ID de correo electrónico válida",
                    email_enter:
                        "Ingrese su ID de correo electrónico registrado",
                    back_link: "Haga clic en Atrás",
                    decline: "Rechazar",
                    signout_thankyou:
                        "Gracias. Le deseamos un exitoso camino hacia una mejor salud.",
                    accept: "Aceptar",
                    block_content: "Bloquear Contenido.",
                    block_user: "Bloquear Usuario.",
                    reason: "Razón",
                    selected_comment: "Comentario Seleccionado",
                    selected_post: "Publicación Seleccionada",
                    offensive: "Ofensivo",
                    "Verification code entered is wrong":
                        "El código de verificación ingresado es incorrecto",
                    "Verification code verified successfully":
                        "Código de verificación verificado exitosamente",
                    spam: "Esta seguro que desea bloqueat a este usuario?",
                    report: "Reportar",
                    unblock_user: "Desbloquear usuario",
                    unblock_discussion: "Desbloquear Discusión",
                    unblock_comment: "Desbloquear comentario",
                    meeting: {
                        note_auto_save:
                            "Las notas se guardan automáticamente, pero toca el botón Guardar después de escribir para asegurarte de que se guarde.",
                        participant_notes: "Notas del participante",
                    },
                    password_exp1:
                        "La URL de la contraseña ha expirado. Por favor haz clic en",
                    password_exp2: "para cambiarla",
                    discussion: {
                        report_comment: "Reportar Esta Publicación",
                        report_post: "Reportar Este Comentario",
                        confirm_block_user:
                            "¿Está seguro de que desea bloquear a este usuario?",
                        confirm_unblock_discussion:
                            "¿Está seguro de que desea desbloquear esta publicación?",
                        confirm_unblock_comment:
                            "¿Está seguro de que desea desbloquear este comentario?",
                        confirm_block_content:
                            "Por favor seleccione la opción que mejor describa su problema.",
                        confirm_unblock_user:
                            "¿Está seguro de que desea desbloquear a este usuario?",
                        reason_placeholder: "Escriba su razón",
                        blocked_user: "Has bloqueado a este usuario",
                        blocked_discussion: "Has bloqueado esta publicación",
                        blocked_comment: "Has bloqueado este comentario",
                        discussion_reactions: {
                            Like: "Me gusta",
                            Love: "Me encanta",
                            Clap: "Aplausos",
                            Celebrate: "Celebrar",
                            Insightful: "Perspicaz",
                            Happy: "Feliz",
                            You_reacted: "Tú reaccionaste",
                            You_and: "Tú y",
                            other: "otro",
                            others: "otros",
                            reacted: "Reaccionó",
                            Comments: "Comentarios",
                            No_Reactions_yet: "Aún no hay reacciones",
                            Reactions: "Reacciones",
                            All: "Todos",
                            Reacted_on: "Reaccionaron en",
                            user_blocked: "Usuario bloqueado",
                        },
                    },
                    banner: {
                        welcome1: `Reconocer los Términos y Condiciones de ${APP_LABEL} es obligatorio para participar en el Programa ${APP_LABEL}.`,
                        welcome2: `Si desea regresar y aceptar los términos y condiciones aplicables para unirse al programa, haga clic en "Regresar".`,
                        welcome3: `Si no desea reconocer los Términos y Condiciones del Programa ${APP_LABEL}, haga clic en el botón Darme de Baja a continuación.`,
                        diabetic1:
                            "Comencemos el registro ingresando el estado de su diabetes.Después, intente llenar tanta información como pueda en los siguientes formularios.",
                        diabetic2:
                            "Todas sus respuestas se mantendrán estrictamente confidenciales y nunca serán asociadas con su nombre.",
                        weight: "Por favor confirma tu peso inicial, y recuerda, ¡esto solo es el principio! Personalizaremos nuestras recomendaciones para ti en base a tu peso inicial. ¡De ahora en adelante te ayudaremos a formar nuevos hábitos y alcanzar tu peso ideal!",
                        complete1: `¡Felicidades! Se ha unido al Programa de Estilo de vida ${APP_LABEL}.`,
                        complete2:
                            "Si aún no ha trabajado con su entrenador, éste se pondrá en contacto con usted en los próximos 3 días hábiles para confirmar su participación.",
                        complete3:
                            "Dentro de la siguiente semana estaremos ordenando su báscula digital si esta está incluida en el programa.",
                        complete4: `Por favor descargue la aplicación de ${APP_ABBREVIATION} en su teléfono y presione el siguiente enlace`,
                        complete5: `Mientras tanto, descarga la aplicación ${APP_LABEL}`,
                        eula_declined1: `Reconocer los Términos y Condiciones de ${APP_LABEL} es obligatorio para participar en el Programa ${APP_LABEL}.`,
                        eula_declined2: `Si desea regresar y aceptar los términos y condiciones aplicables para unirse al programa, haga clic en "Regresar".`,
                        eula_declined3: `Si no desea reconocer los Términos y Condiciones del Programa ${APP_LABEL}, haga clic en el botón "Darme de Baja" a continuación.`,
                        signout_thankyou:
                            "Gracias. Le deseamos un exitoso camino hacia una mejor salud.",
                    },
                    habits: {
                        archive_title:
                            "¿Estás seguro de que quieres archivar este hábito?",
                        activate_title:
                            "¿Estás seguro de que deseas activar este hábito?",
                        add_dialog: {
                            empty: "No has agregado ningún hábito",
                            select_goal: "¿Cuál es el objetivo de tu hábito?",
                            suggested_habit_title: "{{goal_name}} Habits",
                            suggested_habit_subtitle:
                                "Intenta encontrar en el menú desplegable la descripción del hábito en el que quieres trabajar.",
                            description_title:
                                "Describe el hábito con más detalle",
                            description_placeholder:
                                "¿Cómo sabrás si practicaste tu hábito?\n¿por qué estás formando este hábito?\n¿qué podría interferir para que practiques este hábito?",
                            reminder_title: "Enviarme un recordatorio cada:",
                            select_hint: "Elige un hábito que se ajuste a...",
                            custom_hint: "...o escribe el tuyo.",
                            other: "O elija cualquiera de las opciones mostradas más abajo",
                        },
                        confirm_archive:
                            "¿Está seguro de que desea archivar este hábito?",
                        empty: "No hay hábitos para mostrar",
                        archieve_empty:
                            "No hay hábitos archivados para mostrar",
                    },
                    notification_preference: {
                        notification_help_text:
                            'Te enviaremos recordatorios según el horario que configures al crear tus hábitos. Para asegurarte de recibirlos, abre el menú de Ajustes en tu dispositivo, busca la aplicación y asegúrate de que la opción "Permitir notificaciones" esté activada.',
                        learn_notification_help_text:
                            "Obtenga información sobre las preferencias de notificación.",
                    },
                    foods: {
                        add_success: "Agregado exitosamente",
                        update_success: "Actualizado exitosamente",
                        delete_from_list_confirm:
                            "¿Está seguro de que desea eliminar este alimento de la lista?",
                    },
                    form_model: {
                        welcome_description:
                            "¡Iniciemos tu experiencia personalizada!",
                        welcome_secondary_description:
                            "A continuación, responderás algunas preguntas sobre tus metas de bienestar.",
                        thank_you_description:
                            "¡Gracias! Tu respuesta ha sido enviada.",
                        continue: "Continuar",
                        footer_done: "Entregar",
                        footer_next: "Siguiente",
                        footer_previous: "Anterior",
                        date_placeholder: "Elige la fecha de inicio",
                        if_other: "Otro",
                        specify_others: "Por favor, especifica la otra opción",
                    },
                    learn: {
                        empty: "No hay ningún curso configurado para tu programa.",
                        no_content:
                            "No hay contenido disponible para este curso.",
                        header: "¿Listo para aprender nuevos hábitos?",
                        videos: "Videos",
                        handouts: "Folletos",
                        link: "Enlaces",
                        forms: "Formularios",
                        completed: "Completado",
                        hide_details: "Ocultar detalles",
                        view_details: "Ver detalles",
                        links: "Enlaces",
                        video_content: "Video Contenido",
                        handout: "Folleto",
                        form: "Formulario",
                        podcasts: "Pódcasts",
                        podcast: "Podcast",
                        disclaimer:
                            "Los pódcast de esta sección fueron creados con inteligencia artificial. Las voces son simuladas para ayudar a explicar conceptos clave y situaciones de la vida real, basadas en contenido aprobado por los CDC. Estos ejemplos están diseñados solo con fines educativos y no reemplazan el consejo médico profesional. Si tienes preguntas sobre tu salud, habla con un profesional médico.",
                    },
                    podcast: {
                        podcast: "Podcast",
                        comimg_up_next: "A continuación",
                        speed: "Velocidad",
                        play: "Reproducir",
                        pause: "Pausa",
                        next: "Siguiente",
                        select_speed: "Seleccionar velocidad de reproducción",
                    },
                    mandatoryContent: {
                        header: "¡Mantén el ritmo con folletos!",
                        header_desc:
                            "Refuerza lo que aprendiste con estas guías complementarias.",
                        next_doc: "Next Document",
                        close: "Close",
                        mark_read: "Marcar como leído",
                    },
                    mobileModal: {
                        header: "¿Tienes la app móvil?",
                        description:
                            "Para una mejor experiencia, descarga la app móvil.",
                        download: "Descargar ahora",
                    },
                    weekday: {
                        narrow_1: "L",
                        narrow_2: "M",
                        narrow_3: "X",
                        narrow_4: "J",
                        narrow_5: "V",
                        narrow_6: "S",
                        narrow_7: "D",
                        short_1: "Lun",
                        short_2: "Mar",
                        short_3: "Mié",
                        short_4: "Jue",
                        short_5: "Vie",
                        short_6: "Sáb",
                        short_7: "Dom",
                        long_1: "Lunes",
                        long_2: "Martes",
                        long_3: "Miércoles",
                        long_4: "Jueves",
                        long_5: "Viernes",
                        long_6: "Sábado",
                        long_7: "Domingo",
                    },
                    times_per_week: "vez por semana",
                    time_per_week: "vez por semana",
                    mood: "Estado de ánimo",
                    confidence: "Confianza",
                    frequency: "Frecuencia",
                    fixed_days: "Días establecidos",
                    specific_days: "Specific days in a week",
                    flexible_days: "Días flexibles",
                    policy_and_terms:
                        "<0>Política de privacidad</0> y <2>Términos de uso</2>",
                    not_done: "No Hecho",
                    previous: "Anterior",
                    Profile: "Perfil",

                    "Edit profile": "Editar perfil",
                    "Disenroll from": "Cancelar la Inscripción en",
                    "Email is required": "Se requiere un correo",
                    "Invalid email": "Correo inválido",
                    "Password is required": "Se requiere contraseña",
                    "Login Information is Incorrect, 3 wrong attempts will lock your Account":
                        "La Información de inicio de sesión incorrecta, 3 intentos erróneos bloquearán tu cuenta",
                    "Current password": "Contraseña actual",
                    "New password": "Nueva contraseña",
                    "Confirm New Password": "Confirmar nueva contraseña",
                    "Enter your current password":
                        "Introduce tu contraseña actual.",
                    "Enter your new password": "Introduce tu nueva contraseña.",

                    "Re-type new password": "Reescribir nueva contraseña",
                    "Retype your new password":
                        "Vuelve a escribir tu nueva contraseña.",
                    "Retype password": "Reescribir contraseña",
                    "Must contain a letter, a number and a symbol (e.g. hyphen or underscore). It must be at least 8 characters long.":
                        "Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres.",
                    "Must contain a letter, a number and a symbol. It must be at least 8 characters long.":
                        "Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres.",
                    sign_out: "Salir",
                    change_password_hint:
                        "Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres.",
                    Gender: "Género",
                    no_data: "Sin datos",
                    "Mailing Address": "Domicilio",
                    "Mailing address": "Domicilio",
                    "Date of birth": "Fecha de nacimiento",
                    "Date of Birth": "Fecha de nacimiento",
                    "Date of birth is required":
                        "Fecha de nacimiento requerido",
                    "Code entered is wrong":
                        "El código ingresado es incorrecto",
                    Timezone: "Zona horaria",
                    "I have been diagnosed with": "He sido diagnosticado con",
                    "My diabetes status": "He sido diagnosticado con",
                    "Diabetes Status": "Estado de diabetes",
                    "Activity level": "Nivel de actividad",
                    "Activity Level": "Nivel de actividad",
                    "Blood glucose": "Glucemia",
                    "Blood Glucose": "Glucemia",
                    "Blood glucose before breakfast":
                        "Glucosa en sangre antes del desayuno",
                    "Before breakfast": "Antes del desayuno",
                    "Blood glucose after breakfast":
                        "Glucosa en sangre después del desayuno",
                    "After breakfast": "Después del desayuno",
                    "Blood Pressure": "Presión sanguínea",
                    "Current weight": "Peso actual",
                    "Initial weight": "Peso inicial",
                    "How much weight to lose": "Cuánto peso necesita perder",
                    "How much weight you need to lose":
                        "Cuánto peso necesita perder",
                    "Your weight": "Su peso",
                    "Your height": "Su altura",
                    "Your waist": "Su cintura",
                    "Your hips": "Sus caderas",
                    "My waist": "Mi cintura",
                    Waist: "Cintura",
                    "Waist (in inches)": "Cintura (en pulgadas)",
                    "My hips": "Mis caderas",
                    Hips: "Caderas",
                    "Hips (in inches)": "Caderas (en pulgadas)",
                    "Change Password": "Cambiar contraseña",
                    "Change Language": "Cambiar idioma",
                    "Language Preferences": "Preferencias de idioma",
                    Feedback: "Retroalimentación",
                    "Your email": "Su correo",
                    "Your Email ID": "Su dirección de correo electrónico",
                    "Submit feedback": "Subir retroalimentación",
                    Signout: "Salir",
                    "Sign Out": "Desconectar",
                    Password: "Contraseña",
                    "Forgot password?": "¿Olvidaste tu contraseña?",
                    "Sign in": "Ingresar",
                    Login: "Ingresar",
                    Logout: "Salir",
                    new_account:
                        "¿No tiene una cuenta? <1>Regístrate ahora</1>",
                    confirm_address: "Por favor confirme su dirección",
                    every_day: "Cada día",
                    "Need help?": "¿Necesita ayuda?",
                    ask_us: "¿Necesita ayuda? Mándenos un mensaje.",
                    "Ask us": "Mándenos un mensaje",
                    "Privacy policy": "Política de privacidad",
                    "Terms of use": "Términos de uso",
                    Submit: "Subir",

                    "Sync now": "Sincronizar ahora",
                    Syncing: "Sincronizar",
                    manage_notification: "Preferencias de notificación",
                    Create: "Crear",
                    Edit: "Editar",
                    Search: "Buscar",
                    for: "para",
                    And: "y",
                    Cancel: "Cancelar",
                    cancel: "Cancelar",
                    Ok: "Ok",
                    Update: "Actualización",
                    Save: "Guardar",
                    save: "Guardar",
                    Saving: "Ahorro",
                    Comment: "Comentar",
                    Back: "Atrás",
                    back: "Atrás",
                    Add: "Agregar",
                    Notifications: "Notificaciones",
                    "Mark All as Read": "Marcar todo como leído",
                    Done: "Hecho",
                    done: "Hecho",
                    "Not Done": "No Hecho",
                    Discard: "Descartar",
                    "Save changes": "Guardar cambios",
                    "Barcode scanner": "Lector de código de barras",
                    change_password_error:
                        "inválida. Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres",
                    Name: "Nombre",
                    "First name": "Primer nombre",
                    "First Name": "Primer Nombre",
                    "Last name": "Apellido",
                    "Last Name": "Apellido",
                    "Contact number": "Número de contacto",
                    "Contact Number": "Número de contacto",
                    "Enter your phone number": "Ingrese su número de teléfono",
                    "Enter Address line 1": "Ingrese la dirección línea 1",
                    "Enter Address line 2": "Ingrese la dirección línea 2",
                    "Enter City Name": "Ingrese el nombre de la ciudad",
                    "Enter Zip code": "Ingrese el código postal",
                    "Enter your first name": "Ingrese su nombre",
                    "Enter weight": "Ingrese el peso",
                    "Enter steps": "Ingrese los pasos al caminar",
                    "Enter exercise minutes":
                        "Ingrese los minutos de ejercicio",
                    "Add Dish Name": "Agregar nombre del plato",
                    "Add serving unit": "Agregar unidad de servicio",
                    "Add serving quantity": "Agregar cantidad de servicio.",
                    "Enter details": "Ingrese los detalles",
                    "Enter systolic blood pressure":
                        "Ingrese la presión arterial sistólica",
                    "Enter diastolic blood pressure":
                        "Ingrese la presión arterial diastólica",
                    "Enter tobacco count": "Introduzca el recuento de tabaco",
                    "Enter Tobacco count": "Ingrese el conteo de tabaco",
                    "Enter blood sugar value":
                        "Ingrese el valor de azúcar en la sangre",
                    "Add some notes": "Agregar algunas notas",
                    "Enter HbA1c": " Ingrese HbA1c",
                    "Enter your last name": "Ingrese su apellido",
                    "Enter your email": "Ingrese su correo electrónico",
                    "Enter waist size": "Ingrese la talla de cintura",
                    "Enter hips size": "Ingrese la talla de cadera",
                    "Address Line 1": "Dirección 1",
                    "Address Line 2": "Dirección 2",
                    City: "Ciudad",
                    State: "Estado",
                    "Zip code": "Código postal",
                    Male: "Masculino",
                    male: "Masculino",
                    Female: "Femenino",
                    female: "Femenino",
                    View: "Ver",
                    Download: "Descargar",

                    Still: "Quieto",
                    Light: "Ligero",
                    Medium: "Medio",
                    Heavy: "Pesado",

                    "Pre Diabetic": "Prediabético",
                    Diabetic: "Diabético",
                    "No / Not Sure": "No / No está seguro/a",
                    "Not Sure": "No lo sé",
                    "Not sure": "No lo sé",
                    "not sure": "No lo sé",
                    "Prefer not to Answer": "Prefiero no responder",
                    "prefer not to answer": "Prefiero no responder",
                    "Transgender Female": "Mujer trans",
                    "transgender female": "Mujer trans",
                    "Transgender Male": "Hombre trans",
                    "transgender male": "Hombre trans",
                    "Not Listed": "Otra identidad",
                    "not listed": "Otra identidad",
                    "Mandatory fields": "Campos obligatorios",

                    Food: "Alimento",
                    FOOD: "ALIMENTO",
                    Health: "Salud",
                    HEALTH: "SALUD",
                    Discuss: "Discusión",
                    Goals: "Metas",
                    VIDEOS: "VIDEOS",
                    Today: "Hoy",
                    Week: "Semana",
                    Month: "Mes",
                    Year: "Año",
                    WEEK: "Semana",
                    MONTH: "Mes",
                    YEAR: "Año",
                    month: "mes",
                    year: "año",

                    Yes: "Si",
                    Scanning: "Leyendo",

                    "Talk to My Coach": "Hablar con mi entrenador",
                    "Talk to My Team": "Hablar con mi equipo",
                    "TALK TO COACH": "Contacta a tu Coach",
                    "Talk To Your Coach": "Contacta a tu coach",
                    "Type a message": "Escribir un mensaje",
                    close: "Cerrar",
                    January: "enero",
                    February: "febrero",
                    March: "marzo",
                    April: "abril",
                    May: "mayo",
                    June: "junio",
                    July: "julio",
                    August: "agosto",
                    September: "septiembre",
                    October: "octubre",
                    November: "noviembre",
                    December: "diciembre",

                    Fat: "Grasa",
                    Fats: "Grasas",
                    Carbs: "Carbohidratos",
                    Protein: "Proteína",
                    Proteins: "Proteínas",
                    Calories: "Calorías",
                    Cals: "Calorías",

                    fat: "grasa",
                    carbs: "carbohidratos",
                    protein: "proteína",
                    calories: "calorías",
                    cals: "calorías",

                    Serving: "Porción",
                    serving: "porción",
                    "Serving quantity": "Cantidad de porciones",
                    "Serving unit": "Unidades",
                    "Number of servings": "Número de porciones",

                    All: "Todo",
                    Frequent: "Frecuente",
                    Custom: "Personalizado",
                    "My Meals": "Mis comidas",
                    ALL: "Todo",
                    FREQUENT: "Frecuente",
                    CUSTOM: "Personalizado",

                    "Food name": "Nombre del alimento",
                    "Total Fat": "Grasa total",
                    "Total fat": "Grasa total",
                    "Saturated Fat": "Grasas saturadas",
                    "Saturated fat": "Grasas saturadas",
                    Cholesterol: "Colesterol",
                    Sodium: "Sodio",
                    sodium: "sodio",
                    Carbohydrate: "Carbohidrato",
                    Carbohydrates: "Carbohidratos",
                    "Total Carbohydrate": "Carbohidratos totales",
                    "Search Foods": "Buscar alimentos",
                    Fiber: "Fibra",
                    "Dietary Fiber": "Fibra dietética",
                    "Dietary fiber": "Fibra dietética",
                    Sugars: "Azúcares",
                    Sugar: "Azúcares",
                    more: "más",
                    less: "menos",
                    More: "Más",
                    "Vitamin A": "Vitamina A",
                    "Vitamin C": "Vitamina C",
                    "Vitamin D": "Vitamina D",
                    Calcium: "Calcio",
                    Iron: "Hierro",
                    Phosphorus: "Fósforo",
                    Potassium: "Potasio",

                    Breakfast: "Desayuno",
                    Lunch: "Comida",
                    Snacks: "Bocadillos",
                    Dinner: "Cena",
                    BREAKFAST: "DESAYUNO",
                    LUNCH: "COMIDA",
                    SNACKS: "BOCADILLOS",
                    DINNER: "CENA",
                    "You haven't added any food yet":
                        "Aún no has incluido ningún alimento.",
                    "Add food": "Agregar alimento",
                    "Create Custom Food": "Crear alimentos personalizados",
                    "View Nutrition Detail": "Ver detalles nutritivos",
                    "Food log": "Registro de alimentos",
                    "View Food Log": "Ver registro de alimentos",
                    "Total consumption for the day":
                        "Total de calorías en el día",
                    "Edit meal": "Editar alimento",
                    Weight: "Peso",
                    "Goal weight": "Peso meta",
                    "Weight Report": "Reporte de peso", // FIXME: value is received from server
                    "Weight report": "Reporte de peso",
                    "Enter what you have eaten like croissant or chicken enchalada":
                        "Ingrese lo que ha comido, como un croissant o una enchilada de pollo",
                    "No recipes!": "¡Sin recetas!",
                    Recipes: "Recetas",
                    RECIPES: "RECETAS",
                    "Add your own food": "Agregue su propia comida",

                    Exercise: "Ejercicio",

                    "You should exercise for at least 30 mins (or 3500 steps) every day.":
                        "Debe ejercitarse al menos 30 mins (o 3500 pasos) todos los días.",
                    "Number of steps taken today":
                        "Número de pasos el día de hoy",
                    Steps: "Pasos",
                    "Time spent on other exercises":
                        "Tiempo en otros ejercicios",
                    "Exercise types": "Tipos de ejercicios",
                    "Exercise Report": "Reporte de ejercicios",
                    "Exercise report": "Reporte de ejercicios",

                    "You should record atleast blood pressure once every week.":
                        "Debe registrar al menos su presión arterial cada semana.",
                    Systolic: "Sistólico",
                    Diastolic: "Diastólica",
                    "Blood Pressure Report": "Reporte de presión arterial",
                    "Blood pressure report": "Reporte de presión arterial",
                    "Blood Glucose Report": "Reporte de Glucosa en Sangre",
                    "Blood glucose report": "Reporte de glucosa en sangre",

                    Members: "Miembros",
                    Coaches: "Coaches",

                    "My Posts": "Mi publicación",
                    "Pinned Posts": "Publicaciones destacadas",
                    "View My Meetings": "Ver mis reuniones",
                    Replay: "Repitición",
                    "File name": "Nombre de fichero",
                    "File type": "Tipo de archivo",
                    "Are You Sure?": "Estás seguro?",
                    delete: "Delete",

                    "You haven't added any posts":
                        "No ha agregado ninguna publicación",
                    "Subject or title of this post":
                        "Tema o Título de la publicación",
                    "Post a message or describe the files you are sharing":
                        "Publique un mensaje o describa los archivos que compartirá",
                    Message: "Mensaje",

                    "Add Files": "Agregar archivo",
                    Subject: "Asunto",
                    "Enter the subject": "Escribe el asunto",
                    "Enter the message": "Escribe el mensaje",
                    "Subject is required": "El asunto es obligatorio",
                    "Message is required": "El mensaje es obligatorio",
                    Description: "Descripción",
                    edit_post: "Editar publicación",
                    edit: "Editar",
                    "Edit discussion": "Editar discusión",
                    "Update post": "Actualización publicación",
                    Title: "Título",
                    "% Watched": "% observó",
                    Date: "Fecha",
                    Action: "Acción",
                    "Are you sure?": "Estás seguro?",
                    Upload: "Cargar",
                    Delete: "Eliminar",
                    "Select a file": "Seleccione un archivo",
                    "Please upload a valid file":
                        "Por favor cargue un archivo válido",
                    "File is too large, please pick a smaller file":
                        "El archivo es muy grande, por favor elige uno más pequeño",
                    Uploading: "Cargando",
                    loading: "Cargando",
                    Loading: "Cargando",
                    "Upload a File": "Cargar un archivo",
                    "Document name": "Nombre del documento",
                    "Document type": "Tipo de documento",
                    "Max size": "Tamaño máximo",
                    "Choose from the libary": "Elegir de la Biblioteca",
                    "Remove photo": "Borrar foto",
                    "Take photo": "Tomar foto",
                    Post: "Publicar",
                    Share: "Compartir",

                    "Are you sure you want to signout?":
                        "¿Está seguro de que desea salir?",

                    "Max size 15MB (gif, jpg, jpeg, png, pdf)":
                        "Tamaño máximo 15 MB (gif, jpg, jpeg, png, pdf)",
                    device_connected: "Conectado a {{device}}",
                    device_connect: "Conectar a {{device}}",
                    device_connecting: "Conectando a {{device}}",
                    connecting: "Conectando",
                    device_syncing: "Sincronizar",
                    device_sync: "Sincronizar ahora",
                    device_disconnect: "Desconectar a {{device}}",
                    disconnect: "Desconectar",
                    device_disconnecting: "Desconectando",
                    "Connect to": "Conectar a",
                    Device: "Dispositivos",
                    Discussions: "Discusiones",
                    "Carb Counting, part 2": "Conteo de carbohidratos, parte 2",
                    "Carb Counting part 2": "Conteo de carbohidratos parte 2",
                    "Carb Counting, part 1": "Conteo de carbohidratos, parte 1",
                    "Carb Counting part 1": "Conteo de carbohidratos parte 1",
                    "Know Your Fats": "Conozca las grasas",
                    "Managing Your Calories": "Gestionar sus calorías",
                    "Managing Your Calories.": "Gestionar sus calorías",
                    "Three ways to eat less": "Tres formas de comer menos",
                    "Three ways to eat less.": "Tres formas de comer menos.",
                    "Healthy Eating": "Comer saludablemente",
                    "Move your muscles": "Mueva sus músculos",
                    "Being active": "Ser activo",
                    "Tip the calorie balance":
                        "Luche contra la balanza de calorías",
                    "Take charge": "Tenga control",
                    "Problem solving": "Resolución de problemas",
                    "The challenge of eating out": "El reto de comer afuera",
                    "Talk back to negative thoughts":
                        "En contra de los pensamientos negativos",
                    "The slippery slope of life style change":
                        "El cambio de estilo de vida y sus riesgos",
                    "Jump start your activity": "Comience a activarse",
                    "Make social cues work for you":
                        "Haga que los factores sociales le ayuden",
                    "Managing stress": "Manejando el estrés",
                    "Ways to stay motivated": "Formas de mantenerse motivado",
                    "When the weight Loss stalls":
                        "Cuando la pérdida de peso se detiene",
                    "Take a Fitness Break": "Un descanso del ejercicio",
                    "Get Active to Prevent T2": "Actívese para prevenir el T2",
                    "Have Healthy Food You Enjoy":
                        "Consuma comida saludable que disfrute",
                    "Stay Active Away from Home":
                        "Manténgase activo lejos de casa",
                    "Get Enough Sleep": "Duerma lo suficiente",
                    "Get Back on Track": "Vuelva a su rutina",
                    "Prevent T2—for Life!": "Prevenga el T2, ¡de por vida!",
                    "Congratulations !! You have completed your Program":
                        "¡Felicidades! Ha terminado su programa",

                    "Program videos": "Videos del programa",
                    "Demo videos": "Videos de demo",
                    "Set up your scale": "Crear una báscula",
                    "Video 1: HabitNu Program": "Video 1: Programa HabitNu",
                    "Video 2: Carb Counting, part 1":
                        "Video 2: Conteo de carbohidratos, parte 1",
                    "Video 3: Carb Counting, part 2":
                        "Video 2: Conteo de carbohidratos, parte 2",
                    "Video 4: Know Your Fats": "Video 4: Conozca las grasas",
                    "Video 5: Be a Fat Accountant":
                        "Video 5: Sea un contador de grasas",
                    "Video 6: Learn About Calories":
                        "Video 6: Aprendiendo sobre calorías",
                    "Video 7: Managing Your Calories":
                        "Video 7: Gestionar sus calorías",
                    Requested: "Solicitado",
                    Accepted: "Aceptada",
                    "Video 8: Three ways to eat less":
                        "Video 8: Tres formas de comer menos",
                    "Video 9: Healthy Eating": "Video 9: Comer saludablemente",
                    "Video 10: Move your muscles":
                        "Video 10: Mueva sus músculos",
                    "Video 11:Being active": "Video 11: Ser activo",
                    "Video 12: Tip the calorie balance":
                        "Video 12: Luche contra la balanza de calorías",
                    "Video 13: Take charge": "Video 13: Tenga control",
                    "Video 14: Problem solving":
                        "Video 14: Resolución de problemas",
                    "Video 15: The challenge of eating out":
                        "Video 15: El reto de comer afuera",
                    "Video 16: Talk back to negative thoughts":
                        "Video 16: En contra de los pensamientos negativos",
                    "Video 17: The slippery slope of life style change":
                        "Video 17: El cambio de estilo de vida y sus riesgos",
                    "Video 18: Jump start your activity":
                        "Video 18: Comience a activarse",
                    "Video 19:  Make social cues work for you":
                        "Video 19: Haga que los factores sociales le ayuden",
                    "Video 20: Managing stress":
                        "Video 20: Manejando el estrés",
                    "Video 21: Ways to stay motivated":
                        "Video 21: Formas de mantenerse motivado",
                    "Video 22: When the weight Loss stalls":
                        "Video 22: Cuando la pérdida de peso se detiene",
                    "Video 23: Take a Fitness Break":
                        "Video 23: Un descanso del ejercicio",
                    "Video 24: Get Active to Prevent T2":
                        "Video 24: Actívese para prevenir el T2",
                    "Video 25: Have Healthy Food You Enjoy":
                        "Video 25: Consuma comida saludable que disfrute",
                    "Video 26: Stay Active Away from Home":
                        "Video 26: Manténgase activo lejos de casa",
                    "Video 27: Get Enough Sleep":
                        "Video 27: Duerma lo suficiente",
                    "Video 28: Get Back on Track":
                        "Video 28: Vuelva a su rutina",
                    "Video 29: Prevent T2—for Life!":
                        "Video 29: Prevenga el T2, ¡de por vida!",

                    "Together we start a journey towards better health.":
                        "Hoy comenzaremos un nuevo viaje hacia una mejor salud.",
                    "Record a meal": "Registrar una comida",
                    "Step on a scale": "Pararse sobre una báscula",
                    "Watch this week's Video": "Mira el video de esta semana",
                    "Watch the demo video": "Mira el video de esta semana",
                    "Change meal type": "Cambiar tipo de alimento",
                    Version: "Versión",
                    "No Program Videos": "Sin videos",
                    "No program videos": "Sin videos",

                    "Delete meal": "Borrar alimento",
                    "Are you sure you want to delete meal":
                        "¿Está seguro de querer borrar el alimento",
                    "Are you sure you want to delete this meal":
                        "¿Está seguro de querer borrar el alimento",

                    "Delete upload": "Borrar archivo cargado",

                    "Upload/View files": "Cargar/Ver archivos",
                    "Upload files": "Cargar archivos",
                    "Select file to upload": "Elija el archivo a cargar",
                    "Upload file list": "Lista de archivos cargados",
                    "Select Document Type": "Elija el tipo de documento",
                    "Insurance Card": "Tarjeta del seguro",
                    "Insurance Card Front": "Frente de la tarjeta de seguro",
                    "Insurance Card Back": "Reverso de la tarjeta de seguro",
                    "Blood Report": "Reporte sanguíneo",
                    "New post": "Nueva publicación",
                    "Edit post": "Editar publicación",
                    "Add a comment": "Agregar un comentario",
                    "Enter your subject": "Ingrese el tema",
                    "No meetings": "Sin reuniones",
                    "Add note": "Agregar nota",
                    Appointment: "Cita",
                    "Join by phone": "Unirse por teléfono",
                    "Join the meeting using the link":
                        "Únete a la reunión usando el enlace",
                    "Notes to coach": "Notas para el entrenador",
                    Duration: "Duración",
                    "Going?": "Asistir?",
                    "Head Coach": "Coach Principal",
                    "Join Meeting": "Unirse a la reunión",
                    Notes: "Notas",
                    notes: "Notas",
                    Organizer: "Organizador",
                    "Schedule Date & Time": "Fecha y hora programada",
                    "See all comments": "Ver todos los comentarios",
                    Describe: "Descripción",

                    "Join meeting": "Unirse a la reunión",
                    Setting: "Ajuste",
                    Layout: "Distribución",
                    Tiled: "En cuadros",
                    Sidebar: "Barra lateral",
                    Microphone: "Micrófono",
                    Speaker: "Bocina",
                    Resolution: "Resolución",
                    "Front Camera": "Cámara frontal",
                    "Back Camera": "Cámara trasera",
                    "Front camera": "Cámara frontal",
                    "Back camera": "Cámara trasera",
                    Username: "Nombre de usuario",
                    "Send a message to coach":
                        "Mandar un mensaje al Entrenador",
                    PIN: "Anclar",
                    "Add Note": "Agregar Nota",
                    "View nutrition detail": "Ver detalles nutritivos",
                    "Update food": "Actualización alimento",
                    "Login Information is Incorrect":
                        "La información de inicio de sesión es incorrecta",
                    "is required": "se requiere",
                    "Maximum number of files Exceeded (Please upload maximum 5 files)":
                        "Número de archivos máximo excedido (Por favor suba un máximo de 5 archivos)",
                    "The account is currently locked out, Please check your mail for New Password.":
                        "Su cuenta se encuentra bloqueada, por favor revise su correo para obtener una nueva contraseña.",
                    "Learn About Calories": "Aprendiendo sobre calorías",
                    "Be a Fat Accountant": "Sea un contador de grasas",
                    "All Videos Watched !": "Ha visto todos los videos !",
                    "password and retype password should match":
                        "la contraseña y la contraseña reescrita deben coincidir",
                    "is invalid. It must contain a letter, a number and a symbol. It must be at least 8 characters long.":
                        "inválida. Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres",
                    " is invalid.  It must contain a letter, a number and a symbol.  It must be at least 8 characters long.":
                        "inválida. Debe contener una letra, número y símbolo. Debe tener al menos 8 caracteres",
                    "is incorrect": "es incorrecta",
                    "current password is required": "se requiere contraseña",
                    "Welcome To HabitNu Program":
                        "Bienvenido al programa de HabitNu",
                    "Thank you again for joining the HabitNu program - we are thrilled to be working with you, as you learn to navigate the world of better health.":
                        "Le agradecemos nuevamente por unirse al programa de HabitNu; estamos emocionados por comenzar a trabajar con usted mientras aprende a guiarse por un mundo más saludable.",
                    "This program includes the use of the HabitNu App in conjunction with a live coach and group support from your team.":
                        "Este programa incluye el uso de la aplicación HabitNu en conjunción con entrenamientos en vivo y un grupo de soporte en equipo.",
                    "Along with your team, you will learn to track your meals, get more active, and develop new habits.":
                        "Junto a su equipo de soporte aprenderá a registrar sus comidas, volverse más activo y desarrollar nuevos hábitos.",
                    "SIGN ME UP": "UNIRSE",
                    "DISENROLL ME": "CANCELAR INSCRIPCIÓN",
                    "Begin Your Registration": "Comenzar su registro",
                    "Let's begin your registration. Please try to fill in as much of the information on the following forms as you can.":
                        "Comencemos el registro ingresando el estado de su diabetes.Después, intente llenar tanta información como pueda en los siguientes formularios.",
                    "All of your answers will be kept strictly confidential and never associated with your name.":
                        "Todas sus respuestas se mantendrán estrictamente confidenciales y nunca serán asociadas con su nombre.",
                    "Have you been diagnosed with": "Ha sido diagnosticado con",
                    "PRE DIABETES": "PREDIABETES",
                    DIABETES: "DIABETES",
                    "Your preferred contact number":
                        "Número de contacto preferente",
                    Address: "Dirección",
                    "I Confirm My Address": "Dirección confirmada",
                    "My shipments can be delivered to the address above (only applicable if products are included in your program)":
                        "Mis envíos se pueden entregar en la dirección anterior (solo aplicable si los productos están incluidos en su programa)",
                    "My scale can be delivered to the address above (only applicable if a scale is covered by your health plan)":
                        "Mi báscula puede entregarse a la dirección escrita más arriba (solo se aplica si su plan de salud cubre una báscula).",
                    "My lifestyle coach can reach me at the phone number or email address I have supplied":
                        "Mi entrenador de estilo de vida puede comunicarse conmigo al número de teléfono o la dirección de correo que he escrito",
                    NEXT: "SIGUIENTE",
                    "Give your height & weight...":
                        "Escriba su altura y peso...",
                    "Now some exercise facts":
                        "Ahora unos datos sobre el ejercicio",
                    CLOSE: "CERRAR",
                    "Congratulations! You have joined the HabitNu Diabetes Prevention Program.":
                        "¡Felicidades! Se ha unido al programa HabitNu para la prevención de la diabetes.",
                    "Your coach will be in touch with you in the next 3 business days to confirm your participation.":
                        "Su entrenador se pondrá en contacto con usted en los próximos 3 días hábiles para confirmar su participación.",
                    "Within the next week we will be placing an order for your digital scale, if included with your program.":
                        "Dentro de la próxima semana haremos un pedido de su balanza digital, si está incluida en su programa.",
                    "Please download the HabitNu app on your phone by tapping on the link below":
                        "Por favor descargue la aplicación de HabitNu en su teléfono y presione el siguiente enlace",
                    "Thank you for choosing the HabitNu program to guide you on your journey to better health!":
                        "¡Gracias por elegir el programa HabitNu como guía hacia una vida más saludable!",
                    "Thank you for choosing the Project Power program to guide you on your journey to better health!":
                        "¡Gracias por elegir el programa Project Power como guía hacia una vida más saludable!",
                    "Thank you for choosing the What Can I Eat? program to guide you on your journey to better health!":
                        "¡Gracias por elegir el programa What Can I Eat? como guía hacia una vida más saludable!",
                    "NO, OR NOT SURE": "No / No está seguro/a",
                    "password should be atleast 8 characters":
                        "la contraseña debe tener al menos 8 caracteres",
                    "Please enter a valid email Id":
                        "Por favor ingrese una dirección de correo electrónico valida",
                    "Please enter a valid password":
                        "Por favor introduce una contraseña válida.",
                    "Please enter an email": "Por favor introduce tu correo",
                    "Enter your Subject": "Ingrese el tema",
                    "Max Size: 10MB (jpeg, png, pdf, txt, doc)":
                        "Tamaño máximo 10 MB (jpeg, png, pdf, txt, doc)",
                    "Maximum Size: 10 MB": "Tamaño máximo: 10 MB",
                    "Supported Formats: JPG, PNG, PDF, TXT, DOC":
                        "Formatos admitidos: JPG, PNG, PDF, TXT, DOC",
                    "Upload/View Files": "Cargar/Ver archivos",
                    "Select a File to Upload": "Elija el archivo a cargar",
                    Email: "Correo electrónico",
                    "Notes to Coach": "Notas para el entrenador",
                    "If you haven't worked with your coach yet, they will be in touch with you in the next 3 business days to confirm your participation.":
                        "Si todavía no has trabajado con tu entrenador, éste se pondrá en contacto contigo en los próximos 3 días para confirmar tu participación.",
                    "If you are eligible for a scale, we will be placing an order for your digital scale within the next week.  Your coach can confirm your eligibility.":
                        " Si aplicas para una báscula tendremos listo tu pedido de una báscula digital dentro de la semana. Tu entrenador puede confirmar tu elegibilidad.",
                    "powered by": "impulsado por",
                    "Confirm Password": "Confirmar contraseña",
                    "Don't have an account? Register at":
                        "¿No tiene una cuenta? Regístrese en habitnu.com",
                    "Retype Password": "Reescribir contraseña",
                    "Register Now": "Registrarse ahora",
                    "REGISTER NOW!": "REGISTRARSE AHORA!",
                    "Please confirm your starting weight and remember, this is just the beginning! We will customize our recommendations for you based on this starting weight. From this day on we will help you form new Habits to help you reach your goal weight!":
                        "Por favor confirma tu peso inicial, y recuerda, ¡esto solo es el principio! Personalizaremos nuestras recomendaciones para ti en base a tu peso inicial. ¡De ahora en adelante te ayudaremos a formar nuevos hábitos y alcanzar tu peso ideal!",
                    "Please confirm address": "por favor confirme la dirección",
                    "should be greater than 0": "debe ser mayor que 0",
                    "Deleting meal": "Borrando comida",
                    "Please wait": "por favor espera",
                    "Record Blood Glucose": "Registrar glucosa en sangre",
                    "How many times did you use tobacco today?":
                        "¿Cuántas veces consumió tabaco hoy?",
                    Tobacco: "Tabaco",
                    "Record Tobacco Count": "Registrar el conteo de tabaco",
                    "Tobacco Count": "Conteo de tabaco",
                    "Tobacco Count Report": "Reporte de conteo de tabaco",
                    "Share Screen": "Compartir pantalla",
                    "Send a message": "Mandar mensaje",
                    "Stop Sharing": "Deja de compartir",
                    "has to be equal or longer than 8 characters!":
                        "¡tiene que ser igual o mayor a 8 caracteres!",
                    "Max size 10Mb": "Tamaño máximo 10 MB",
                    "My height": "Mi altura",
                    "Feet/Inches(ft)": "Pies/Pulgadas (ft)",
                    "Centimeters(cm)": "Centímetros (cm)",
                    Centimeters: "Centímetros",
                    Height: "Altura",
                    feet: "pies",
                    Feet: "Pies",
                    inches: "pulgadas",
                    Inches: "Pulgadas",
                    "Account is De-Activated!! Please contact your Admin":
                        "¡Su cuenta ha sido desactivada! Por favor contacte a un administrador",
                    Fruits: "Frutas",
                    Dairy: "Lácteos",
                    Grains: "Granos",
                    Legumes: "Leguminosas",
                    "Nuts & seeds": "Semillas de nuez",
                    "Starchy vegetables": "Verduras con almidón",
                    "Non-starchy vegetables": "Verduras sin almidón",
                    "Tobacco count": "Recuento de tabaco",
                    "Blood sugar": "Glucemia",
                    "Blood Sugar": "Glucemia",
                    "Add New": "Agregar nuevo",
                    Details: "Detalles",
                    details: "Detalles",
                    "No data recorded yet": "Aún no hay datos registrados",
                    "Last 30 days": "Últimos 30 días",
                    "Date and Time": "Fecha y hora",
                    Walking: "Caminando",
                    running: "corriendo",
                    Other: "Otro",
                    other: "Otro",
                    Report: "Reporte",
                    skip: "Saltar",
                    "Last month": "mes pasado",
                    "Last week": "semana pasada",
                    "Last year": "año pasado",
                    Actions: "Accións",
                    "Walking/Running": "Caminando/Corriendo",
                    Connect: "Conectar",
                    "Created weight": "Peso creado",
                    "Please enter valid weight":
                        "Por favor ingresa un peso válido",
                    weight: "peso",
                    "Weight cannot be blank":
                        "El peso no puede quedar en blanco",
                    "Created exercise": "Ejercicio creado",
                    "Steps cannot be blank":
                        "Los pasos no pueden estar en blanco",
                    "Minutes must be less than or equal to 1440":
                        "Los minutos deben ser menores o iguales a 1440",
                    "Minutes cannot be blank":
                        "Los minutos no pueden quedar en blanco",
                    "Created blood pressure": "Presión sanguínea creada",
                    "Systolic cannot be blank":
                        "La sistólica no puede quedar en blanco",
                    "Diastolic cannot be blank":
                        "La diastólica no puede quedar en blanco",
                    "Systolic should be a valid entry":
                        "La sistólica debe ser una entrada válida",
                    "Diastolic should be a valid entry":
                        "La diastólica debe ser una entrada válida",
                    "Created tobacco count": "Conteo de tabaco creado",
                    "Tobacco count cannot be blank":
                        "El conteo de tabaco no puede quedar en blanco",
                    "Please enter a valid tobacco count":
                        "Por favor ingresa un valor de conteo de tabaco válido",
                    "Blood sugar cannot be blank":
                        "El azúcar en la sangre no puede quedar en blanco",
                    "Blood sugar cannot be blank, Reading Time cannot be blank":
                        "El azúcar en la sangre no puede quedar en blanco. El tiempo de lectura no puede quedar en blanco",
                    "Created blood sugar": "Se creó el azúcar en la sangre",
                    "Please enter a valid blood sugar":
                        "Por favor ingresa un valor válido de azúcar en la sangre",
                    "No data for last 30 days":
                        "Sin datos de los últimos 30 días",
                    "Steps must be less than or equal to 100000":
                        "Los pasos deben ser menores o iguales a 100000",
                    "Minutes must be greater than zero":
                        "Los minutos debe ser mayor que 0",
                    minutes: "minutos",
                    Minutes: "Minutos",
                    Hours: "Horas",
                    Hour: "Hora",
                    Copy: "Copiar",
                    Copied: "Copiado",
                    systolic: "Sistólico",
                    diastolic: "Sistólico",
                    "Complete Your Registration": "Completa tu registro",
                    "Let's Build your Profile": "Vamos a crear tu perfil",
                    "Step 1": "Paso 1",
                    "Basic Information": "Información básica",
                    "Step 2": "Paso 2",
                    "Address Information": "Dirección",
                    "Step 3": "Paso 3",
                    "Health Information": "Información del seguro",
                    "Please add valid quantity":
                        "Por favor agrega una cantidad válida",
                    "Connect your devices": "Conecta tus dispositivos",
                    "To record your vitals":
                        "Para registrar tus signos vitales",
                    Devices: "Dispositivos",
                    "7 DAYS": "7 Días",
                    "4 WEEKS": "4 Semanas",
                    "1 YEAR": "1 Año",
                    "Set Target": "Establecer objetivo",
                    "Set your target": "Establecer tu objetivo",
                    Target: "Objetivo",
                    "Do you really want to delete weight?":
                        "Peso ¿Realmente deseas eliminar el peso?",
                    "Must be greater than or equal to 1":
                        "Debe ser mayor o igual a 1",
                    "Must be less than or equal to 999":
                        "Debe ser menor o igual a 999",
                    "Weight must have 1 digits after decimal":
                        "El peso debe de tener un dígito después del punto decimal",
                    "Must be less than or equal to 99":
                        "Debe ser menor o igual a 99",
                    "Other Activity": "Otra actividad",
                    "Please enter a valid number":
                        "Por favor ingresa un número válido",
                    "Do you really want to delete exercise?":
                        "Ejercicio ¿Realmente deseas eliminar el ejercicio?",
                    "Steps must be greater than or equal to 1":
                        "Los pasos deben ser mayores o iguales a 1",
                    "Minutes must be greater than or equal to 1":
                        "Los minutos deben ser mayores o iguales a 1",
                    "Minutes must have 2 digits after decimal or less":
                        "Los minutos deben tener 2 dígitos después del decimal o menos",
                    "Systolic must be greater than or equal to 1":
                        "Sistólico debe ser mayor o igual a 1",
                    "Diastolic must be greater than or equal to 1":
                        "Diastólico debe ser mayor o igual a 1",
                    "Do you really want to delete blood pressure?":
                        "Presión arterial ¿Realmente deseas eliminar la presión arterial?",
                    "Do you really want to delete tobacco count?":
                        "Conteo de tabaco ¿Realmente deseas eliminar el conteo de tabaco?",
                    "Do you really want to delete blood sugar?":
                        "Azúcar en la sangre ¿Realmente deseas eliminar el azúcar en la sangre?",
                    "Your Coach will get in touch with you soon":
                        "Tu Entrenador se pondrá en contacto contigo pronto",
                    Cohort: "Compañero",
                    "View Profile Details": "Ver detalles del perfil",
                    "View profile": "Ver perfil",
                    "Password do not match": "La Contraseña no coincide",
                    "Manage Devices": "Administrar dispositivos",
                    Manage: "Administrar",
                    "Please enter all the fields":
                        "Por favor ingresa todos los campos",
                    "Let's build your profile": "Construyamos tu perfil",
                    Scanned: "Escaneada",
                    "activity must be one of the following values: still, light, medium, heavy":
                        "la actividad debe ser uno de los siguientes valores: quieto, ligero, medio, pesada",
                    Retry: "Reintentar",
                    "Read All": "Leer todo",
                    "email must be a valid email":
                        "debe ingresar un correo válido",
                    "Forgot password": "¿Olvidaste tu contraseña",
                    "The account is currently locked out, Please check your mail for New Password":
                        "Su cuenta se encuentra bloqueada, por favor revise su correo para obtener una nueva contraseña",
                    "password do not match": "La Contraseña no coincide",
                    "You are not currently assigned to any Discussion Group":
                        "Actualmente no está asignado a ningún grupo de discusión",
                    "HabitNu Program Overview":
                        "Descripción del programa HabitNu",
                    "Video 31: Food Preparation and Recipe Modification":
                        "Video 31: Preparación de alimentos y modificación de recetas",
                    "Video 30: Why Manage Weight":
                        "Video 30: Por qué manejar el peso",
                    "Video 32: Stress and Time Management":
                        "Video 32: Estrés y organización del tiempo",
                    "Video 33: Stepping Up to Physical Activity":
                        "Video 33: Comenzar la actividad física",
                    "Video 34: More volume, lesser calories":
                        "Video 34: Más volumen, menos calorías",
                    "Video 35: Staying on Top of Physical Activity":
                        "Video 35: Mantener la actividad física",
                    "Current Weight": "Peso actual",
                    "Today's Total": "Total de hoy",
                    "Current Blood Pressure": "Presión arterial actual",
                    "Current Blood Sugar": "Azúcar en la sangre actual",
                    "Total count for day": "Conteo total en el día",
                    "Diastolic must be less than or equal to 200":
                        "Diastólico debe ser menor o igual a 200",
                    "Feedback submitted": "Retroalimentación enviada",
                    "High blood sugar must be greater than or equal to 1":
                        "La azúcar alta en la sangre debe ser mayor o igual a 1",
                    "Low blood sugar must be less than or equal to 999":
                        "La azúcar baja en la sangre debe ser menor o igual a 999",
                    "High blood sugar must be less than or equal to 999":
                        "La azúcar alta en la sangre debe ser menor o igual a 999",
                    "Systolic must be less than or equal to 250":
                        "Sistólico debe ser menor o igual a 250",
                    "Target Blood Pressure": "Objetivo Presión sanguínea",
                    "Syncing...": "Sincronizar...",
                    "Current HbA1c": "HbA1c actual",
                    "HbA1c cannot be blank": "HbA1c no puede estar en blanco",
                    "Do you really want to delete hba1c?":
                        "¿Realmente deseas eliminar hba1c?",
                    "HbA1c must have 2 digits after decimal or less":
                        "HbA1c debe contener 2 dígitos o menos después del decimal",
                    "Must be greater than or equal to 4":
                        "Debe ser mayor o igual a 4",
                    "Must be less than or equal to 14":
                        "Debe ser mayor o igual a 14",
                    Habits: "Hábitos",
                    HABITS: "HÁBITOS",
                    Habit: "Hábito",
                    morning: "Mañana",
                    noon: "Tarde",
                    reminder: "Recordatorio",
                    next: "Siguiente",
                    night: "Noche",
                    "Manage notifications": "Administrar notificaciones",
                    "Notification Preferences":
                        "Preferencias de notificaciones",
                    "Habit Tracker": "Rastreador de hábitos",
                    Push: "Emergentes",
                    On: "Encendido",
                    Off: "Apagado",
                    "We send reminders to you following the schedule defined when you created each habit. We will also send informational messages to help on your journey to forming healthy habits. You can turn on or off where you wish to receive these messages. We find that SMS and push notifications (which pop up on your phone and take you right into our app) are the most effective way to receive this kind of message.":
                        "Te enviamos recordatorios de acuerdo con el horario que definiste al crear cada hábito. También te enviaremos mensajes informativos para ayudarte en tu viaje a crear hábitos saludables. Puedes activar o desactivar la manera de recibir estos mensajes. Hemos descubierto que los SMS y las notificaciones emergentes (las que aparecen en tu teléfono y te llevan directamente a la aplicación) son la forma más eficaz de recibir estos mensajes.",
                    "Target Weight": "Peso meta",
                    "Sync devices": "Sincronizar dispositivos",
                    "Sync Now": "Sincronizar ahora",
                    "Daily Target": "Objetivo diario",
                    "Target Tobacco Count": "Meta de la cantidad de tabaco",
                    "Target Blood Sugar": "Meta de la glucosa en sangre",
                    "Target HbA1c Count": "Conteo HbA1c objetivo",
                    Fasting: "Ayuno",
                    "Before Meal": "Antes del alimento",
                    "After Meal": "Después del alimento",
                    "Reading Time": "Tiempo de lectura glucosa",
                    "Contact number must be at least 10 characters":
                        "El número de contacto debe tener al menos 10 caracteres",
                    "Contact number cannot be more than 15 characters":
                        "El número de contacto no puede tener más de 15 caracteres",
                    "Contact Number is invalid": "Número de contacto no válido",
                    "Address line 1 cannot start with a space":
                        "La línea 1 de la dirección no puede comenzar con un espacio",
                    "City name cannot be empty or spaces only":
                        "El nombre de la ciudad no puede estar vacío o contener solo espacios",
                    "I confirm my address": "Dirección confirmada",
                    "I confirm": "Confirmo",
                    "Health parameters": "Parámetros de salud",
                    "Health Parameters": "Parámetros de salud",
                    "Health parameter": "Parámetro de salud",
                    "Contact details": "Detalles de contacto",
                    "Contact Details": "Detalles de contacto",
                    "Basic information": "Información básica",
                    "Basic information updated":
                        "Información básica actualizada",
                    "Contact details updated":
                        "Detalles de contacto actualizados",
                    "Health parameters updated":
                        "Parámetros de salud actualizados",
                    "Give your weight": "da tu peso",
                    "Please select": "Por favor seleccione",
                    "Created hba1c": "HbA1c creado",
                    "Must be greater than or equal to 0":
                        "Debe ser mayor o igual a 0",
                    Low: "Baja",
                    High: "Alta",
                    "Non-step minutes": "Minutos sin pasos",
                    "Are you sure you want to remove this food from the list?":
                        "¿Está seguro de que desea eliminar este alimento de la lista?",
                    "Diabetes status is required":
                        "Estado de diabetes requerido",
                    "Please select feet and inches":
                        "Por favor seleccione pies y pulgadas",
                    "Activity level is required":
                        "Nivel de actividad requerido",
                    "No diagnosis": "Sin diagnóstico",
                    "Zip code is required": "Código postal requerido",
                    "State is required": "Estado requerido",
                    "City is required": "Ciudad requerida",
                    "Address line is required": "Dirección requerida",
                    "Address line 1 cannot be more than 35 characters":
                        "La línea 1 de la dirección no puede tener más de 35 caracteres.",
                    "Zip code must be either 5 digits (XXXXX) or 9 digits (XXXXX-XXXX)":
                        "El código postal debe ser de 5 dígitos (XXXXX) o de 9 dígitos (XXXXX-XXXX).",
                    "Zip code must be either 6 digits (XXXXX)":
                        "El código postal debe ser de 6 dígitos (XXXXX)",
                    "Zip code must have a leading zero if it's 4 digits long":
                        "El código postal debe tener un cero inicial si tiene 4 dígitos",
                    "Contact number is required":
                        "Número de contacto requerido",
                    "Enter weight you need to loose":
                        "Ingresa el peso que necesitas perder",
                    "Enter your current weight": "Ingresa tu peso actual",
                    "Contact number is invalid": "Número de contacto inválido",
                    "Time Zone is required": "Zona horaria requerida",
                    "Please enter a valid date of birth":
                        "Por favor ingrese una fecha de nacimiento válida",
                    "Sex is required": "Este campo es obligatorio",
                    "First Name is required": "Nombre requerido",
                    "Not available": "No disponible",
                    "You don't have any notifications!":
                        "¡No tiene ninguna notificación!",
                    "Congratulations! You have joined the HabitNu Lifestyle Program.":
                        "¡Felicidades! Se ha unido al Programa de Estilo de vida HabitNu.",
                    "Within the next week we will be placing an order for your digital scale if one is included with your program.":
                        "Dentro de la siguiente semana estaremos ordenando su báscula digital si esta está incluida en el programa.",
                    "Thank you again for joining the HabitNu program - we are thrilled to be working with you as you learn to navigate the world of better health.":
                        "Le agradecemos nuevamente por unirse al programa de HabitNu; estamos emocionados por comenzar a trabajar con usted mientras aprende a guiarse por un mundo más saludable.",
                    "Non step mins": "Minutos sin pasos",
                    "Synced with withings, garmin and fitbit":
                        "Sincronizado con withings, garmin y fitbit",
                    "Synced withings, garmin, and fitbit":
                        "Sincronizado withings, garmin y fitbit",

                    "Failed to sync": "Hubo un error al sincronizar",
                    "Please disconnect and connect again.":
                        "Desconéctese y vuelva a conectarse de nuevo.",
                    "Go to device management":
                        "Ir a administración de dispositivos",
                    "kudos! You are doing great, Keep it up.":
                        "¡¡prestigio!! Lo estás haciendo muy bien, sigue así.",
                    "Serving Unit": "Unidades",
                    "Serving Qty": "Cantidad de porciones",
                    yes: "sí",
                    Confirm: "Confirmar",
                    "Add Food": "Agregar alimento",
                    "Welcome to HabitNu program":
                        "Bienvenido al programa de HabitNu",
                    "Welcome to Project Power program":
                        "Bienvenido al programa de Project Power",
                    "Sign me up": "Unirse",
                    "Disenroll me": "Cancelar Inscripcon",
                    "Begin your registration": "Comenzar su registro",
                    Mountain: "Montaña",
                    Eastern: "Este",
                    Hawaiian: "Hawaii",
                    Pacific: "Pacífico",
                    "How much weight you need to lose?(lbs)":
                        "Cuánto peso necesita perder?(lbs)",
                    "Get my reset link":
                        "Mandar por correo el enlace de restauración",
                    "Diastolic cannot be blank. Systolic cannot be blank":
                        "La diastólica no puede quedar en blanco. La sistólica no puede quedar en blanco",
                    "Video 1: Project Power Program":
                        "Video 1: Programa Project Power",
                    max_electro: "Máxima actividad electrodérmica del mes",
                    bone_mass: "Masa ósea",
                    muscle_mass: "Masa muscular",
                    fat_mass: "Masa grasa",
                    "Bone Mass (lbs)": "Masa ósea (lbs)",
                    "Muscle Mass (lbs)": "Masa muscular (lbs)",
                    "Fat Mass (lbs)": "Masa grasa (lbs)",
                    "Disenrolling will result in loss of access to the Project Power app and to your health coach":
                        "Desinscribirse tendrá como resultado la pérdida del acceso a la aplicación Project Power y su promotor de salud.",
                    "Disenrolling will result in loss of access to the HabitNu app and to your health coach":
                        "Desinscribirse tendrá como resultado la pérdida del acceso a la aplicación HabitNu y su promotor de salud.",
                    "Reason for disenrolling:": "Motivo para desinscribirse:",
                    "I am not well enough to participate":
                        "No me encuentro lo suficientemente bien como para participar",
                    "I don't have a stable network": "No tengo una red estable",
                    "Class location is too far away":
                        "Me encuentro demasiado ocupado",
                    "Too busy right now": "Me encuentro demasiado ocupado",
                    "It is too technical": "Es demasiado técnico",
                    "Program is not helping me": "El programa no me ayuda",
                    "Signing in": "Iniciando sesión",
                    "Access Denied": "Acceso denegado",
                    "Last sync on": "Última sincronización",
                    Sync: "Sincronizar",
                    "Contact us": "Contáctanos",
                    Category: "Categoría",
                    "Choose category": "Elige una categoría",
                    "Need help? We're here to assist you":
                        "¿Necesitas ayuda? Estamos aquí para ti.",
                    "Update Food": "Actualizar los alimentos",
                    "Signing up": "Regístrate",
                    "Reading Time cannot be blank":
                        "La lectura no puede estar en blanco",
                    Discussion: "Discusión",
                    DISCUSSIONS: "DISCUSIÓN",
                    "Passwords do not match": "Las contraseñas no coinciden",
                    Learn: "Aprender",
                    LEARN: "APRENDER",
                    "Failed to connect to Fitbit account":
                        "No se pudo conectar a la cuenta de Fitbit",
                    Reconnect: "Reconectar",
                    "Fitbit failed to sync. Please reconnect.":
                        "Fitbit no pudo sincronizarse. Por favor, reconecta.",
                    "Your Fitbit device has been disconnected. Please click here to reconnect the device.":
                        "Tu Fitbit está desconectado. Haga clic aquí para volver a conectar",
                    "Your Fitbit device has been disconnected":
                        "Tu Fitbit está desconectado",
                    "Please click here": "Haga clic aquí",
                    "to reconnect the device": "para volver a conectar",
                    "Not Synced": "No sincronizado",
                    "Class Materials": "Materiales de clase",
                    "Successfully Disenrolled User":
                        "Usuario cancelado exitosamente",
                    "Profile picture updated": "Foto de perfil actualizada",
                    Viewed: "Visto",
                    Documents: "Documentos",
                    documents: "documentos",
                    Disconnected: "Desconectar",
                    normal: "Normal",
                    low: "Bajo",
                    no_match_email:
                        "No se encontraron usuarios con ese correo electrónico.",
                    "Fitbit failed to sync": "Fitbit no pudo sincronizarse",
                    "Please reconnect": "Por favor, reconecta",
                    "Account is Not Activated!! Please contact your Admin":
                        "¡Cuenta no activada! Por favor, contacta a tu administrador",
                    "Weight loss goal is required":
                        "se requiere objetivo de pérdida de peso",
                    "Weight loss goal must be greater than or equal to 1":
                        "el objetivo de pérdida de peso debe ser mayor o igual a 1",
                    "Weight loss goal must be less than or equal to 999":
                        "el objetivo de pérdida de peso debe ser menor o igual a 999",
                    "Electrodermal Activity": "Electrodérmica",
                    "Body Composition": "Composición corporal",
                    "Weight loss goal must have 1 digits after decimal point":
                        "El objetivo de pérdida de peso debe de tener un dígito después del punto decimal",
                    Monday: "lunes",
                    Tuesday: "martes",
                    Wednesday: "miércoles",
                    Thursday: "jueves",
                    Friday: "viernes",
                    Saturday: "sábado",
                    Sunday: "domingo",
                    chat_unacessible_toast_message:
                        "Actualmente no estás asignado con ningún Coach para chatear.",
                    initiation_message:
                        "Su tiempo es muy valioso para nosotros.  En algún momento, tome un tiempo para proporcionarnos esta información a HabitNu y poder servirle mejor. Por favor, revise los siguientes formularios que su coach ha solicitado.",
                    review_forms: "Formulario de Revisión",
                    Close: "Cerrar",
                    fill_form_message:
                        "Por favor, elija el formulario que le gustaría llenar primero.",
                    Meals: "Comidas",
                    Days: "Días",
                    "Track Weight": "Peso",
                    Available: "Disponible",
                    Home: "Inicio",
                    HOME: "INICIO",
                    complete: "Completo",
                    Completed: "Completado",
                    "Days per Week": "Días por semana",
                    "Minutes per Day": "Minutos por día",
                    "Times Per Week": "Veces por semana",
                    lbs: "libras",
                    mins: "minutos",
                    "Step on scale must be less than or equal to 7":
                        "Pesarse debe ser menor o igual a 7",
                    "Meal must be less than or equal to 7":
                        "La comida debe ser menor o igual a 7",
                    "Exercise must be less than or equal to 1440":
                        "El ejercicio debe ser menor o igual a 1440",
                    "Weight must be less than or equal to 999":
                        "El peso debe ser menor o igual a 999",
                    "Step on scale cannot be blank":
                        "El paso en la balanza no puede estar en blanco",
                    "Meal cannot be blank":
                        "La comida no puede estar en blanco",
                    "Exercise cannot be blank":
                        "El ejercicio no puede estar en blanco",
                    network_error:
                        "Tu conexión a internet es inestable. Intenta apagar tu video o conectarte por teléfono.",
                    "Target weight can't be same as initial weight":
                        "El peso objetivo no puede ser el mismo que el peso inicial",
                    "Complete!": "Completo!",
                    "Monounsaturated Fat": "Grasa monoinsaturada",
                    "Polyunsaturated Fat": "Grasa poliinsaturada",
                    Selecting: "Seleccionar",
                    "will reset your nutrition and calorie goals to the default settings based on your current weight. Are you sure you want to proceed?":
                        "restablecerá tus objetivos de nutrición y calorías a la configuración predeterminada según tu peso actual. ¿Estás seguro de que deseas continuar?",
                    Cholestrol: "Colesterol",
                    general_content: {
                        fitness_videos_header: "Videos de fitness",
                        fitness_video_text:
                            "Entrenamientos para todos los cuerpos.",
                        try_these_next: "¡Prueba estos a continuación!",
                        no_video_error: "No hay videos configurados.",
                        failed_to_load_content: "No se pudo cargar el video.",
                        exercise_videos: "Videos de ejercicios.",
                        banner_description:
                            "Mejora tu rutina con entrenamientos que se adapten a tu estilo.",
                        workout_now: "Entrena ahora",
                        connected_devices: "Conectar dispositivos",
                        connected_dev_desc:
                            "¡Sincroniza tus dispositivos para un seguimiento fluido y actualizaciones sin interrupciones!",
                    },
                    Medication: "Medicamentos",
                    "Add your medication": "Agrega tus medicamentos",
                    medication: {
                        "": "",
                        headers: {
                            add_medication: "Agrega medicamentos",
                            view_medication: "Ver medicamento",
                            edit: "Editar medicamento",
                            history: "Historial de medicamentos",
                            log_history: "Historial de registros",
                        },
                        log_success: "Medicamento registrado con éxito",
                        alertMsg:
                            "En caso de emergencia, llama al 911. Si te sientes mal, consulta con el médico que te recetó el tratamiento.",
                        type_here: "Escribe aquí",
                        "Weight Loss Medication":
                            "Medicamento para bajar de peso",
                        "Other Medication": "Otro medicamento",
                        review_header: "¿Cómo te sientes hoy?",
                        symptoms_label: "¿Tiene alguno de estos síntomas?",
                        symptoms_other:
                            "Especifica cualquier otra opción que no aparezca en la lista:",
                        medication: "Medicamentos",
                        card_description: "Agrega tus medicamentos",
                        log: "Registro",
                        add_time: "Agregar hora",
                        add_time_label:
                            "¿A qué hora planeas tomar este medicamento?",
                        time_label: "Hora",
                        time: "Tora",
                        your_medication: "Tus medicamentos",
                        as_needed_medication:
                            "Medicamentos según sea necesario",
                        todays_logs: "Registro de hoy",
                        skipped: "Omitido",
                        taken: "Tomado",
                        medication_empty: "No hay medicamentos para mostrar.",
                        reminder_empty: "No hay medicamentos que registrar.",
                        reminder_done: "¡Buen trabajo! ¡Estás al día!",
                        archived_medication: "Medicamentos archivados",
                        next_reminder: "Próximo recordatorio a las",
                        till: "Hasta",
                        next_reminder_at: "Próximo recordatorio a las",
                        archive: "Archivar",
                        archive_description:
                            "Consulta aquí todos tus medicamentos archivados.",
                        fixed_days: "Días fijos",
                        form: {
                            name_label: "Nombre del medicamento",
                            name_placeholder:
                                "Ingresa el nombre de tu medicamento",
                            strength_label: "Concentración",
                            form_type_label: "Tipo/Forma",
                            dosage_label: "Dosis",
                            dosage_description: "En cada toma",
                            start_date_label: "Desde",
                            end_date_label: "Hasta",
                            continuous_label:
                                "Medicamento continuo (sin fecha de término)",
                            food_timing_label:
                                "Horario relacionado con la comida",
                            food_timing_placeholder:
                                "Horario relacionado con la comida",
                            frequency_label: "Frecuencia",
                            comment_label: "Comentarios",
                            comment_placeholder: "Escribe tus comentarios aquí",
                            reminder_label: "Recordatorio de medicamento",
                            unit_label: "Unidad",
                        },
                        medication_timing: "Horarios de medicamentos",
                        view_history: "Ver historial",
                        "Fixed Days": "Días fijos",
                        Capsule: "Cápsula",
                        Tablet: "Tableta",
                        Liquid: "Líquido",
                        Topical: "Tópico",
                        Injection: "Inyección",
                        Application: "Application",
                        Unit: "Unidad",
                        unit: "Unit",
                        Ml: "ml",
                        ml: "ml",
                        Other: "Otro",
                        "Before Food": "Antes de comer",
                        "After Food": "Después de comer",
                        Daily: "Diario",
                        "Every other day": "Un día sí, un día no",
                        "Twice weekly": "Dos veces por semana",
                        Weekly: "Cada semana",
                        "Every other week": "Cada dos semanas",
                        "As needed": "Según sea necesario",
                        Fixed: "Fijo",
                        Flexible: "Flexible",
                        Day: "Día",
                        Week: "Semana",
                        Month: "Mes",
                        Year: "Año",
                        Taken: "Tomado",
                        "Not Taken": "No tomado",
                        medication_history: "Historial de medicamentos",
                        history_description:
                            "Consulta tu historial de medicamentos aquí.",
                        no_history:
                            "No hay historial de medicamentos disponible.",
                        Nausea: "Náuseas",
                        Vomiting: "Vómito",
                        Diarrhea: "Diarrea",
                        Constipation: "Estreñimiento",
                        Dizziness: "Mareos",
                        Headache: "Dolor de cabeza",
                        "Hypoglycemia (low blood sugar level)":
                            "Hipoglucemia (nivel bajo de azúcar en sangre)",
                        "Injection site reaction":
                            "Reacción en el área de la inyección",
                    },
                    "All Occurrance": "Todas las tomas",
                    "Ounce (oz)": "Onza (oz)",
                    "Milliliter (ml)": "Mililitro (ml)",
                    "Required field": "Campo requerido",
                    "Must be more than 0": "Debe ser mayor a 0",
                    "Time already exist": "La hora ya existe",
                    "Marked as Taken at": "Marcado como Tomado a las",
                    "Marked as Not Taken at": "Marcado como No Tomado a las",
                    "Should be after from date":
                        "Debe ser después de la fecha de inicio",
                    Morning: "Mañana",
                    Noon: "Mediodía",
                    Night: "Noche",
                    recipe_book: {
                        generate_new_recipe: "Generar nueva receta",
                        save_ingredient: "Guardar ingrediente",
                        upload_photo: "Subir foto",
                        search_recipe: "Buscar receta personalizada",
                        preparation_instruction: "Instrucciones de preparación",
                        recipe_photo: "Receta foto",
                        servings: "Porciones",
                        create_custom_recipe: "Crear receta personalizada",
                        please_enter_valid_serving_size:
                            "Por favor ingresa un tamaño de porción válido",
                        enter_serving_size: "Ingresa el tamaño de la porción",
                        custom_recipe: "Mis recetas",
                        create_recipe: "Crear receta",
                        recipe_updated_toast: "Recipe Updated succesfully",
                        update_recipe: "Actualizar receta",
                        add_ing: "Buscar y agregar ingrediente",
                        servings_num: "Número de porciones",
                        edit_recipe: "Editar receta",
                        invalid_serving_qty: "El valor mínimo es 0.01",
                        update_recipe_text:
                            "Actualiza los detalles e ingredientes de tu receta personalizada.",
                        recipe_name: "Nombre de la receta",

                        total_calories: "Calorías totales",
                        recipe_log_toast: "Receta registrada correctamente",
                        preparation_instructions:
                            "Instrucciones de preparación",
                        invalid_serving_size:
                            " El tamaño de la porción debe ser mayor que 0.25",
                        serving_size_placeholder:
                            "Ingresa el tamaño de la porción",
                        favourite_toast: "Receta añadida a favoritos",
                        already_added_toast: "Agregado a los ingredientes",
                        delete_confirm:
                            "¿Estás seguro de que quieres eliminar esta receta?",
                        ingredient_name: "Nombre del ingrediente",
                        unfavourite_toast: "Receta eliminada de favoritos",
                        delete_toast: "Receta eliminada con éxito",
                        recipe_created_successfully: "Receta creada con éxito",
                        no_recipe_header: "No hay recetas personalizadas",
                        no_recipe_description:
                            "No se encontraron recetas personalizadas",
                        cal: "calorías",
                        for_servings: "para {{count}} porciones",
                        add_ingredient_quantity:
                            "Agregar cantidad de porciones",
                        add_ingredient_name: "Agregar nombre del ingrediente",
                        create_recipe_description:
                            "Agrega ingredientes, establece las porciones y guarda en tu libro de recetas.",
                        name_placeholder: "Ingresa el nombre de la receta",

                        recipe_updated_successfully:
                            "Receta actualizada con éxito",
                        save_ingredients: "Guardar ingredientes",
                        ing_added_toast: "Agregado correctamente",
                        remove_ing_toast: "Ingrediente eliminado correctamente",
                        ing_removed_toast: "Eliminado",
                        ing_already_added_toast:
                            "{{ingredientName}} ya agregado",
                        please_enter_ingredient_name:
                            "ingresa el nombre del ingrediente",
                        custom_ingredient_added:
                            "Ingrediente personalizado agregado",
                        enter_recipe_name: "Ingresa el nombre de la receta",
                        add_at_least_one_ingredient:
                            "Agrega al menos un ingrediente",
                        calories: "Calorías",
                        servings_unit: "Porciones",
                        add_custom: "Agregar ingrediente personalizado",
                        detailed_nutrition_facts:
                            "Datos nutricionales detallados",
                        total_fat: "Grasa total",
                        saturated_fat: "Grasa saturada",
                        trans_fat: "Grasa trans",
                        vitamin_d: "Vitamina D",
                        calcium: "Calcio",
                        iron: "Hierro",
                        potassium: "Potasio",
                        cholesterol: "Colesterol",
                        sodium: "Sodio",
                        total_carb: "Carbohidratos totales",
                        dietary_fiber: "Fibra dietética",
                        sugars: "Azúcares",
                        added_sugars: "Azúcares añadidos",
                        protein: "Proteína",
                        ingredients: "Ingredientes",
                        generate: "Generar",
                        recipe_book: "Libro de recetas",
                        recipes: "Recetas",
                        recipe_book_desc_habi:
                            "Convierte ingredientes cotidianos en tu comida perfecta.",
                        recipe_book_desc:
                            "¡Busca en la web recetas deliciosas y guarda tus favoritas en la aplicación!",
                        recently_generated_recipes: "Generado recientemente",
                        history_recipes: "Historial",
                        habi_recipes: "Recetas de Habi",
                        search_web: "Buscar en la web",
                        recipe_disclaimer:
                            "Por favor, ten en cuenta: Estos son valores aproximadosy pueden variar dependiendo de los ingredientes específicos que utilices y sus marcas.",
                        instructions: "Instrucciones",
                        change_recipe_title: "¿No te encanta esta receta?",
                        change_recipe_desc:
                            "¡Cambiemos la receta o digámosle adiós!",
                        regenerate: "Regenerar",
                        log_recipe: "Registrar receta",
                        set_preferences: "Establecer Preferencias",
                        remove_from_favorite: "Eliminar de Favoritos",
                        add_to_Favorite: "Agregar a Favoritos",
                        delete_recipe: "Eliminar Receta",
                        are_you_sure: "¿Estás seguro?",
                        recipe_generated: "Receta generada",
                        recipe_generating: "Tu receta se está generando...",
                        recipe_failed: "No se pudo generar la receta",
                        favoriteAdded: "Receta añadida a favoritos",
                        delete_recipe_confirm:
                            "Esta receta será eliminada. Presiona Sí para confirmar.",
                        back_to_recipe: "Volver a la receta",
                        recipe_soon:
                            "Tu receta se generará pronto. ¡Puedes seguir usando la aplicación mientras tanto!",
                        disclaimer:
                            "Estas recetas son generadas por IA y pueden no ser completamente precisas. Por favor, usa tu criterio al preparar el plato.",
                        disclaimer2:
                            "Las recetas se proporcionan únicamente con fines informativos y no constituyen asesoramiento médico ni nutricional. Algunas recetas pueden ser generadas por inteligencia artificial o provienen de terceros. No garantizamos la precisión, el contenido nutricional ni la idoneidad dietética. Siempre revise los ingredientes por posibles alérgenos y consulte a un profesional de la salud calificado si es necesario. Al utilizar estas recetas, usted asume todos los riesgos y libera a nosotros, nuestras afiliadas y socios de cualquier responsabilidad relacionada con los resultados, problemas de salud o reacciones alérgicas.",
                        no_recipe_found:
                            "No se encontró ninguna receta, por favor revisa tu término de búsqueda.",
                    },
                    "Add Ingredients": "Agregar ingredientes",
                    "dietary restrictions": "Restricciones dietéticas",
                    "dietary preferences": "Preferencias dietéticas",
                    "strictness of dietary preferences":
                        "Rigor de las preferencias dietéticas",
                    "macronutrient considerations":
                        "Consideraciones de macronutrientes",
                    "micronutrient considerations":
                        "Consideraciones de micronutrientes",
                    "local food preferences":
                        "Preferencias de alimentos locales",
                    "diet goals": "Objetivos dietéticos",
                    "food allergies": "Alergias alimentarias",
                    "specific dietary considerations":
                        "Consideraciones dietéticas específicas",
                    "Select any allergies or food sensitivities Habi should avoid adding to your recipe suggestions":
                        "Seleccione cualquier alergia o sensibilidad alimentaria que Habi debería evitar agregar a sus sugerencias de recetas.",
                    "Let Habi know which ingredients you prefer to limit in your recipe suggestions":
                        "Hazle saber a Habi qué ingredientes prefieres limitar en tus sugerencias de recetas.",
                    "Select your macronutrient preference below to help Habi create healthy options for your specific needs":
                        "Seleccione su preferencia de macronutrientes a continuación para ayudar a Habi a crear opciones saludables para sus necesidades específicas.",
                    "Select micronutrients below that you would like increased in your meal suggestions from Habi":
                        "Seleccione a continuación los micronutrientes que le gustaría aumentar en sus sugerencias de comidas de Habi.",
                    "Let's make your meals work for you!":
                        "¡Hagamos que tus comidas funcionen para ti!",
                    "Select all the dietary restrictions that apply to you:":
                        "Selecciona todas las restricciones dietéticas que te apliquen:",
                    "We want to know what you love!":
                        "¡Queremos saber lo que te gusta!",
                    "Select all your dietary preferences:":
                        "Selecciona todas tus preferencias dietéticas:",
                    "How committed are you to your food choices?":
                        "¿Qué tan comprometido estás con tus elecciones alimenticias?",
                    "Let us know:": "Déjanos saber:",
                    "Tell us your macronutrient style and specific needs:":
                        "Cuéntanos tu estilo de macronutrientes y necesidades específicas:",
                    "We’ve got the details covered.":
                        "Nos encargamos de los detalles.",
                    "Select your micronutrient needs:":
                        "Selecciona tus necesidades de micronutrientes:",
                    "Your local food preferences matter!":
                        "¡Tus preferencias alimenticias locales importan!",
                    "Select all that apply:":
                        "Selecciona todo lo que corresponda:",
                    "Let’s hit your targets!": "¡Alcancemos tus objetivos!",
                    "What are your diet goals?":
                        "¿Cuáles son tus objetivos dietéticos?",
                    "Stay safe and sound!": "¡Mantente seguro y saludable!",
                    "Select all your food allergies:":
                        "Selecciona todas tus alergias alimenticias:",
                    "Any special considerations?":
                        "¿Alguna consideración especial?",
                    Peanuts: "Cacahuates",
                    Eggs: "Huevos",
                    Fish: "Pescado",
                    Shellfish: "Mariscos",
                    Sesame: "Sésamo",
                    Wheat: "Trigo",
                    Soy: "Soya",
                    Meat: "Carne",
                    Spices: "Especias",
                    Iodine: "Yodo",
                    Kosher: "Kosher",
                    "Tree Nuts": "Frutos secos",
                    "Processed Foods": "Alimentos procesados",
                    "Gluten-Free": "Sin Gluten",
                    "Plant-Based": "Basado en plantas",
                    "High Carbs": "Altos carbohidratos",
                    "High Fat": "Alto en grasas",
                    "Low Protein": "Bajo en proteínas",
                    "Low Carbs": "Bajos en carbohidratos",
                    "Low Sugar": "Bajo en Azúcar",
                    "Low Fat": "Bajo en Grasas",
                    "Low Carb": "Bajo en Carbohidratos",
                    "Gluten Free": "Sin Gluten",
                    "High Fiber": "Alto en Fibra",
                    "Mollusk Free": "Sin Moluscos",
                    "Dairy Free": "Sin Lácteos",
                    "No Sugar": "Sin Azúcar",
                    "High Protein": "Alto en Proteínas",
                    "Alcohol Free": "Sin Alcohol",
                    "Kidney Friendly": "Amigable para los Riñones",
                    "Low Potassium": "Bajo en Potasio",
                    Mediterranean: "Mediterránea",
                    "No Oil Added": "Sin Aceite Añadido",
                    "Pork Free": "Sin Cerdo",
                    "Red Meat Free": "Sin Carne Roja",
                    "Sugar Conscious": "Consciente del Azúcar",
                    "Sulfite Free": "Sin Sulfitos",
                    Vegan: "Vegano",
                    Vegetarian: "Vegetariano",
                    Pescatarian: "Pescatariano",
                    Paleo: "Paleo",
                    Flexitarian: "Flexitariano",
                    Keto: "Keto",
                    DASH: "DASH",
                    Balanced: "Equilibrado",
                    "Very Strict": "Muy estricto",
                    "I never deviate from my dietary preferences":
                        "Nunca me desvío de mis preferencias dietéticas",
                    Flexible: "Flexible",
                    "I generally follow my dietary preferences but often make exceptions":
                        "Generalmente sigo mis preferencias dietéticas, pero a menudo hago excepciones",
                    Moderate: "Moderado",
                    "I mostly follow my dietary preferences but occasionally deviate":
                        "Principalmente sigo mis preferencias dietéticas, pero ocasionalmente me desvío",
                    Water: "Agua",
                    Standard: "Estándar",
                    "Zinc (Zn)": "Zinc (Zn)",
                    Folate: "Folato",
                    "Folate (Equivalent)": "Folato (Equivalente)",
                    Magnesium: "Magnesio",
                    "No Allergies": "Sin alergias",
                    "Egg Free": "Sin huevo",
                    "Soy Free": "Sin soja",
                    "Fish Free": "Sin pescado",
                    "Celery Free": "Sin apio",
                    "Crustacean Free": "Sin crustáceos",
                    "Lupine Free": "Sin altramuces",
                    "Mustard Free": "Sin mostaza",
                    "Peanut Free": "Sin maní",
                    "Sesame Free": "Sin sésamo",
                    "Shellfish Free": "Sin mariscos",
                    "Tree Nut Free": "Sin frutos secos",
                    "Wheat Free": "Sin trigo",
                    "FODMAP Free": "Sin FODMAP",
                    "Folic Acid": "Ácido fólico",
                    Seasonal: "Estacional",
                    transactions: {
                        header: "Historial de transacciones y facturas",
                        no_invoices: "No hay facturas disponibles",
                        validity: "Validez",
                        billing_history: "Historial de facturación",
                    },
                    purchase: "Compra",
                    renewal: "Renovación",
                    note: "Nota",
                    "Yearly Plan": "Plan anual",
                    "Yearly plan": "Plan anual",
                    "Annual plan": "Plan anual",
                    "Annual Plan": "Plan anual",
                    "Monthly Plan": "Plan mensual",
                    "Monthly plan": "Plan mensual",
                    Monthly: "Mensual",
                    monthly: "mensual",
                    Yearly: "Annual",
                    yearly: "annual",
                    "Billed Monthly": "Billed Monthly",
                    "Billed Yearly": "Billed Yearly",
                    "I don't use it enough": "No lo uso lo suficiente",
                    "Too expensive": "Demasiado caro",
                    "Switching to something else": "Cambiando a algo diferente",
                    "Just taking a break": "Solo tomaré un descanso",
                    active: "activo",
                    Active: "Activo",
                    canceled: "cancelado",
                    expired: "vencido",
                    smart_insights: {
                        explore_insights:
                            "Tus Insights de Salud Inteligentes están listos!",
                        title: "Ideas Inteligentes",
                        subtitle: "Recibe nuevos insights cada lunes!",
                        week_header: "Resumen de la semana pasada",
                        empty_state_message_one:
                            "Los Insights de Salud Inteligente están impulsados por ti.",
                        empty_state_message_two:
                            "Registra tus comidas y minutos de actividad para desbloquear tus insights.",
                        disclaimer: "Aviso",
                        goal_text: "Pequeños pasos, grandes resultados",
                        disclaimer_text:
                            "Los Smart Insights se generan mediante IA a partir de tu actividad en el programa HabitNu Thrive. Se proporcionan únicamente con fines educativos y de bienestar, y no constituyen asesoramiento médico. Consulta siempre a tu profesional de la salud sobre tu estado o tratamiento.",
                        close: "Cerrar",
                        feedback_prompt: "Comparte tus comentarios",
                        feedback_header: "¿Algo más que tquieras contarnos?",
                        feedback_subheader: "(opcional)",
                        type_here: "Escribe aquí",
                        send: "Enviar",
                        empty_state_message:
                            "Las Smart Health Insights se generan con tus datos. Registra tu comida y actividad para desbloquear tus insights.",
                        feedback_comment_label:
                            "Cuéntanos un poco más sobre tu experiencia...",
                        feedback_cancel_button: "Cerrar",
                        feedbackSuccess: "¡Gracias por tus comentarios!",
                        feedback_cleared: "Comentarios eliminados",
                        disclaimer_acknowledge: "Cerrar",
                        feedbackError: "Error al enviar comentarios",
                    },

                    subscriptions: {
                        billing_faq: "Preguntas frecuentes de facturación",
                        contact_support: "Contactar Soporte",
                        confirm_stop_auto_renew:
                            "¿Estás seguro de que deseas detener la renovación automática?",
                        current_subscription: "Suscripción actual",
                        terms_external_subscription_link:
                            "Al {{actionWord}} <b>Suscribirte</b>, reconoces y aceptas nuestros términos",
                        desc: "Obtén acceso completo a todas las funciones de la aplicación y mantente en camino con tus objetivos.",
                        terms: "Al hacer clic en <b>Suscribirse</b>, usted reconoce y acepta nuestras",
                        terms_link: "Términos y Condiciones.",
                        header: "Gestionar suscripciones",
                        looking_for_payments: "¿Buscas tus pagos o acturas?",
                        manage_subscriptions: "Gestionar suscripciones",
                        member_since: "Miembro Desde {{date}}",
                        need_help: "¿Necesitas ayuda?",
                        please_specify: "Por favor especifica",
                        type_here: "Escribe aquí",
                        need_help_desc:
                            "¿Necesitas ayuda con algo? ¡Estamos aquí para ayudarte!",
                        plan: "Plan",
                        continue: "Continuar",
                        select_plan: "Seleccionar un plan",
                        refund_policy: "Política de cancelación y reembolso",
                        stop_auto_renewal: "Detener renovación automática",
                        next_billing_data:
                            "Tu próxima fecha de facturación es <strong>{{date}}</strong>",
                        plan_expire_on:
                            "Tu plan vencerá el <strong>{{date}}</strong>",
                        transaction: "Transacción",
                        transaction_invoice_history:
                            "Historial de transacciones y Facturas",
                        auto_renewal_platform:
                            "Por favor, detén la renovación automática a partir de {{provider}}",
                        stop_auto_renewal_apple:
                            "Esta suscripción se realizó a través de iOS. Para cancelar o gestionar la renovación automática, visita la configuración de tu Apple ID en tu iPhone, iPad o Mac.",
                        stop_auto_renewal_google:
                            "Esta suscripción se compró a través de Google Play. Para cancelar o gestionar la renovación automática, ve a la configuración de tu cuenta de Google Play en tu dispositivo Android.",
                        subscribe_to_continue_now:
                            "¡Suscríbete para continuar ahora!",
                        subscribe_to_continue: "Suscríbete para continuar",
                        already_subscribed: "Ya estás suscrito",
                        subscribe_to_continue_desc:
                            "Tu programa ha terminado, pero tu viaje apenas comienza.",
                        subscribe_to_continue_desc_program_ending:
                            "Con todas las funciones de la aplicación al alcance de tu mano, tendrás el poder de alcanzar tus objetivos y mantener tu progreso.",
                        subscription: "Suscripción",
                        manage_subscription: "Administrar Suscripción",
                        privacy_policy: "Política de Privacidad",

                        currency: "Moneda",
                        start_date: "Fecha de inicio",
                        next_billing_date: "Fecha de próximo pago",
                        auto_renew: "Renovación automática",
                        payment_method: "Método de pago",

                        renew_on: "Renovar el",
                        end_date: "Fecha de finalización",
                        your_next_billing_date: "Tu próxima fecha de pago es",
                        status: "Estado",
                        included_with: "Incluido con",
                        sub_status: "Estado de Suscripción",
                        click_to_unlock:
                            "Haz clic aquí para desbloquear todas las funciones.",
                        subscribe_now: "Suscríbete ahora",
                        stop_auto_renewal_header:
                            "¿Detener la renovación automática?",
                        stop_auto_renewal_desc:
                            "Perderás el acceso a funciones clave como el registro de alimentos, las recetas y el seguimiento una vez que tu plan finalice el <strong>date</strong>.",
                        subscribe: "Suscribirse",
                        end_auto_renewal: "Finalizar renovación automática",
                        end_auto_renewal_header:
                            "¿Finalizar renovación automática?",
                        subscribe_and_get_everything:
                            "¡Suscríbete y obtén todo!",
                        whats_included: "Qué incluye",
                        why_ending_subscription:
                            "¿Por qué estás cancelando tu suscripción?",
                        no_plan_included: "No hay planes disponibles",
                        sub_billing_history: "Historial de facturación",
                    },
                    payment_modal: {
                        you_are_all_set: "¡Ya está todo listo!",
                        sub_status: "Estado de suscripción",
                        plan: "Plan",
                        next_billing_date: "Próxima fecha de facturación",
                        receipt: "Recibo",
                        go_to_login: "Ir a Iniciar sesión",
                        go_to_app: "Ir a la aplicación",
                        emailed: "Enviado por correo electrónico",
                    },
                    "Device sync": "Sincronización de dispositivos",
                    "Fitness videos": "Videos de fitness",
                    "Habit and goal tracking":
                        "Seguimiento de hábitos y objetivos",
                    "Medication log and reminders":
                        "Registro de medicamentos y recordatorios",
                    "HabitAI personal progress insights":
                        "Información sobre el progreso personal de HabitAI",
                    "Smart nutritional recommendations":
                        "Recomendaciones nutricionales inteligentes",
                    "Personalized recipe builder and more!":
                        "¡Creador de recetas personalizado y mucho más!",
                    Hey: "Ey",
                    Geographical: "Geográfico",
                    Organic: "Orgánico",
                    Sustainable: "Sostenible",
                    "I prefer foods that are local to my area":
                        "Prefiero alimentos que son locales de mi área",
                    "I prefer foods that are in season":
                        "Prefiero alimentos que están en temporada",
                    "I prefer ingredients that are organic":
                        "Prefiero ingredientes que sean orgánicos",
                    "I prefer food with low environmental impact":
                        "Prefiero alimentos con bajo impacto ambiental",
                    "Limits fats, cholesterol and sodium":
                        "Limita las grasas, el colesterol y el sodio",
                    "Allows some meat and dairy, while mostly vegetarian":
                        "Permite algo de carne y productos lácteos, aunque es mayoritariamente vegetariano",
                    "Eliminates certain carbs, like garlic and onion":
                        "Elimina ciertos carbohidratos, como el ajo y la cebolla",
                    "Restricts foods containing gluten proteins":
                        "Restringe los alimentos que contienen proteínas de gluten",
                    "Contains higher fat and protein, while limiting carbs":
                        "Contiene más grasas y proteínas, al tiempo que limita los carbohidratos",
                    "Complies with strict dietary standards of Jewish law":
                        "Cumple con los estrictos estándares dietéticos de la ley judía",
                    "Consists of meat, fish, fruits and vegetables":
                        "Se compone de carne, pescado, frutas y verduras",
                    "Mostly vegetarian, but allows for fish and seafood":
                        "Mayormente vegetariano, pero permite pescados y mariscos",
                    "Contains only foods and ingredients sourced from plants":
                        "Contiene únicamente alimentos e ingredientes procedentes de plantas",
                    "Avoids all animal-based foods, including honey":
                        "Evita todos los alimentos de origen animal, incluida la miel",
                    "Allows for vegetables and dairy, but no meat or seafood":
                        "Permite verduras y lácteos, pero no carne ni mariscos",
                    "Limits foods that are processed or inflammatory":
                        "Limita los alimentos procesados o inflamatorios",
                    "Lose Weight": "Perder peso",
                    "Maintain Weight": "Mantener peso",
                    "Gain Weight": "Ganar peso",
                    "Improve Overall Health": "Mejorar la salud general",
                    "Increase Muscle Mass": "Aumentar la masa muscular",
                    "Immuno Supportive": "De apoyo inmunológico",
                    "Search Ingredients": "Buscar Ingredientes",
                    "Type the subject/title here":
                        "Escribe el asunto/título aquí",
                    "Let's share what going on your mind":
                        "Comparte lo que tienes en mente",
                    "Let's get started!": "¡Comencemos!",
                    "We are thrilled to be a part of your journey to better health!":
                        "¡Nos encanta ser parte de tu camino hacia una mejor salud!",
                    "Do you have a recent diabetes diagnosis?":
                        "¿Tienes un diagnóstico reciente de diabetes?",
                    "Do you have hypertension?": "¿Tienes hipertensión?",
                    No: "No",
                    "What is your goal weight?": "¿Cuál es tu peso objetivo? ",
                    kg: "kilos",
                    Kg: "Kilos",
                    "Current Physical Activity":
                        "Nivel actual de actividad física",
                    "Choose current physical activity":
                        "Elige tu nivel actual de actividad física",
                    "Thank you!": "¡Gracias!",
                    "We wish you a successful journey towards better health!":
                        "¡Te deseamos mucho éxito en tu camino hacia una mejor salud!",
                    "End User License Agreement":
                        "Acuerdo de licencia para el usuario final",
                    Disenrolling: "Darse de baja",
                    "Fill in your details to personalize your experience":
                        "Completa tus datos para personalizar tu experiencia",
                    "Setup Later": "Configurar más tarde",
                    "Enter last name": "Escribe tu apellido",
                    "Enter first name": "Escribe tu primer nombre",
                    "Enter your preferred name":
                        "Escribe el nombre que prefieres usar",
                    "Preferred Name": "Nombre preferido",
                    "Time Zone": "Zona horaria",
                    "Phone Number": "Número de teléfono",
                    "Enter phone number": "Ingresa el número de teléfono",
                    "Enter address": "Ingresa la dirección",
                    "Enter city": "Ingresa la ciudad",
                    "ZIP Code": "Código postal",
                    "Enter ZIP code": "Ingresa el código postal",
                    "Almost done!": "¡Falta poco!",
                    "Final step! Let’s wrap this up":
                        "¡Ya casi! Solo queda un último paso.",
                    "Loading options": "Cargando opciones",
                    "Choose your diabetes diagnosis":
                        "Indica tu diagnóstico de diabetes",
                    "Height must be an object with feet and inches":
                        "La altura debe ingresarse en pies y pulgadas",
                    "Weight is required": "El peso es requerido",
                    "Weight must be a valid number":
                        "El peso debe ser un número válido",
                    "Weight loss goal must be a valid number":
                        "La meta de pérdida de peso debe ser un número válido",
                    "Weight loss goal must be a positive number":
                        "La meta de pérdida de peso debe ser un número positivo",
                    "Weight loss goal must have at most 1 digit after the decimal point":
                        "La meta de pérdida de peso debe tener como máximo 1 decimal",
                    target_weight_same_error:
                        "El peso objetivo no puede ser igual al peso inicial",
                    "Hypertension status is required":
                        "Se requiere el estado de hipertensión",
                    "Height is required": "Se requieren altura",
                    "Feet is required": "Se requieren pies",
                    "Inches is required": "Se requieren pulgadas",
                    Disenroll: "darse de baja",
                    "Enter email": "Ingrese su correo electrónico",
                    "Choose sex": "Elige tu sexo",
                    "Choose time zone": "Elige la zona horaria",
                    "Phone Number is required":
                        "Se requiere el número de teléfono",
                    "Address Line 1 is required":
                        "Se requiere la línea de dirección 1",
                    "Select a state": "Seleccione un estado",
                    "Congratulations! Your profile is complete!":
                        "¡Felicidades! ¡Tu perfil está completo!",
                    "Please select height in feet & inches or centimetres":
                        "Por favor, selecciona la altura en pies e pulgadas o centímetros",
                    "Be on the lookout for your Welcome Email":
                        "Espera tu correo de bienvenida",
                    "In the meantime, download the HabitNu app":
                        "Mientras tanto, descarga la aplicación HabitNu",
                    Finish: "Finalizar",
                    "Select an option": "Selecciona una opción",
                    "Height Unit": "Unidad de altura",
                    "Weight Unit": "Unidad de peso",
                    "Phone Number must be at least 10 characters":
                        "El número de teléfono debe tener al menos 10 caracteres.",
                    "Phone Number is invalid": "número de teléfono no válido",
                    "Phone number cannot be more than 15 characters":
                        "El número de teléfono debe tener menos de 15 caracteres",
                    "First name must contain only letters and spaces":
                        "El primer nombre solo puede incluir letras y espacios",
                    "Are you sure you want to continue?":
                        "¿Estás seguro de que deseas continuar?",
                    "You’ll be leaving this site and visiting an external page":
                        "Dejarás este sitio y visitarás una página externa",
                    "Click yes to proceed": "Haz clic en sí para continuar",
                    "Serving size must be at least 1":
                        "El tamaño de la porción debe ser al menos 1.",
                    explore: {
                        Discussion: "Discusión",
                        Recipes: "Recetas",
                        "Fitness Videos": "Videos de fitness",
                        Medications: "Medicamentos",
                    },
                    food_group: {
                        meal: "Comida",
                        review_meal: "Crear comida",
                        tweak_combo:
                            "¡Agrupa tus comidas favoritas para un seguimiento más rápido!",
                        breakfast_mon: "Desayuno del lunes",
                        meal_name: "Nombre de la comida",
                        remove_photo: "Eliminar",
                        foods_added: "Artículos de comida añadidos a la comida",
                        food_added_success: "¡Alimento agregado con éxito!",
                        save_meal: "Guardar comida",
                        meal_created: "Comida creada",
                        meal_updated: "Comida actualizada",
                        save_group_failed:
                            "Error al guardar el grupo. Por favor, inténtalo de nuevo.",
                        name_required: "El nombre es requerido",
                        add_more: "Agregar alimento",
                        add_2_foods:
                            "Agrega al menos 2 alimentos para crear un grupo de comidas.",
                        my_meals: "Mis comidas",
                        edit_meal: "Editar comida",
                        log_meal: "Registrar comida",
                        no_food_found: "No se encontraron alimentos",
                        no_data: "Sin datos",
                        create_meal: "Crear comida",
                        meal_logged_success: "Comida registrada con éxito",
                        log_meal_error:
                            "No se pudo registrar la comida. Por favor, inténtelo de nuevo.",
                        meal_deleted_success: "Comida eliminada con éxito",
                        delete_meal_error:
                            "La comida no puede ser eliminada. Por favor, inténtalo de nuevo.",
                        log_all_foods:
                            "¿Estás seguro de que deseas registrar todos los {{count}} alimentos en {{name}} como {{mealType}}?",
                        food_delete_confirm:
                            "Este alimento será eliminado. Presiona Sí para confirmar.",
                        foods: "Alimentos",
                        Foods: "Alimentos",
                        upload_photo: "Subir foto",
                        delete_meal_confirm:
                            "¿Estás seguro de que deseas eliminar esta comida?",
                    },
                    Disclaimer: "Advertencia",
                    "Add breakfast": "Agregar desayuno",
                    "Add lunch": "Agregar comida",
                    "Add dinner": "Agregar cena",
                    "Add snacks": "Agregar bocadillos",
                },
            },
        },

        fallbackLng: "en",
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: ".",
        nsSeparator: "|",

        interpolation: {
            escapeValue: false,
        },
    })
    .then(() => {
        // Check if localStorage has en-GB and convert it to en
        const storedLng = localStorage.getItem("i18nextLng");
        if (storedLng && storedLng.startsWith("en-")) {
            localStorage.setItem("i18nextLng", "en");
            void i18n.changeLanguage("en");
        }
    });

export default i18n;
